import React, { useState, useEffect, useRef } from "react";

import Parse from "parse/dist/parse.min.js";
import "bootstrap/dist/css/bootstrap.css";
import "react-awesome-button/dist/styles.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { ColoredDivider } from "../ColoredDivider/ColoredDivider";
import { EachDecision } from "../EachDecision/EachDecision";
import Swal from "sweetalert2";

import avatar from "../../assets/images/avatar.png";
import PopupWithBackdrop, {
  ConfirmModal,
  PuzzleCaseModal,
  YesterdayAnswerModal,
  MenuModal,
  IntroModal,
  TypeAnswerModal,
  ScoreModal,
  ZoomingModal,
  ZoomCase,
  WebModal,
  LevelWarning,
} from "../Modals/Modals";
import "./HomePage.css";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";
import { PGSDK } from "../../pgsdk";
import tommorrowButton from "../../assets/images/tommorrowButton.png";
import yesterdayButton from "../../assets/images/yesterdayButton.png";
import lock from "../../assets/images/lock.png";
import played from "../../assets/images/played.png";

import smartLogo from "../../assets/images/logo.png";
import geniusLogo from "../../assets/images/genius.png";
import NextLogo from "../../assets/images/nextin.png";
import newLogo from "../../assets/images/today.png";
import Schermafbeelding from "../../assets/images/Schermafbeelding.png";
import { OrbitProgress } from "react-loading-indicators";
import { Dashes } from "../Dashes/dashes";
import { Cloud } from "parse";
import axios from "axios";
import { Genius } from "../Genius/Genius";
import { FaqModal } from "../FAQ/FaqModal";
import amplitude from "amplitude-js";
import { DecodeCGToken } from "../../Crazy";
import LoadAnimation from "../LoadAnimation/LoadAnimation";
import WriteCommentModal from "../Modals/WriteCommentModal";

import { getInstance, Env } from "@arkadiuminc/sdk";
let isArkadium = false;
let arksdk;// = await getInstance();
//arksdk.lifecycle.onTestReady();
//Arkadium^


export let globalCounter = "";

export const preventScrollWheel = (event) => {
  event.preventDefault();
};

export const preventScrollKeydown = (event) => {
  if (["ArrowUp", "ArrowDown", " "].includes(event.key)) {
    event.preventDefault();
  }
};

function HomePage() {
  const portalHomeReadySentRef = useRef(false);
  const [start, setStart] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);

  //AD TRIGGERS
  //const adTriggerGenius = 2;
  const adTriggerSolution = 13;
  //----------
  // const geniusChallengesInStock = 41;
  //----------

  const fromDate = new Date(2022, 0, 1); // January is month 0
  const currentDate = new Date();
  const timeDiff = currentDate.getTime() - fromDate.getTime();
  const [quotePrefill, setQuotePrefill] = useState("");
  // console.log('currentDate',currentDate)
  // console.log('timeDiff',timeDiff)
  const utcCurrent = Date.UTC(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const utcFrom = Date.UTC(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate()
  );

  const diffInDays = Math.floor((utcCurrent - utcFrom) / (1000 * 60 * 60 * 24));

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  let idString = isArkadium? "10000": urlParams.get("id");
  var idAsNumber = isArkadium? diffInDays: parseInt(idString, 10);

  var classToBeLoaded = "ExtRiddle";
  const [alreadyPlayed, setAlreadyPlayed] = useState(false);

  const [yestBoolean, setYestBoolean] = useState(false);
  const [isIntroPopupOpen, setIsIntroPopupOpen] = useState(false);
  const [isTodaysExplanationForPremium, setIsTodaysExplanationForPremium] =
    useState(false);

  //GENIUS
  let [isGenius, setIsGenius] = useState(false);
  let [tableView, setTableView] = useState(false);

  const demoString = urlParams.get("demo");

  const noIntroString = urlParams.get("noIntro");
  const noIntroBoolean = noIntroString === "true";

  const hideButtonsString = urlParams.get("hideButtons");
  const hideButtonsBoolean = hideButtonsString === "true";

  var isTodaysDayRiddle = false;
  var isYesterdaysDayRiddle = false;

  let publisherID = isArkadium? "ark": urlParams.get("pubID");
  // if (isArkadium) {
  //   publisherID = ;
  // }

  const publisherSubID = urlParams.get("subPubID");
  let langString = urlParams.get("lang");
  if (langString === null) {
    langString = "en";
  }

  const [isPremium, setIsPremium] = useState(false);
  const [isPuzzleCaseModalClosed, setIsPuzzleCaseModalClosed] = useState(false);
  useEffect(() => {
    if (
      publisherID === "usaPremium" ||
      publisherID === "wapoPremium" ||
      publisherID === "erdeePremium"
    ) {
      setIsPremium(true);
    }
  }, [publisherID]);

  useEffect(() => {
    if (hideButtonsBoolean) {
      document.documentElement.classList.add("hide-buttons");
    } else {
      document.documentElement.classList.remove("hide-buttons");
    }
    return () => {
      document.documentElement.classList.remove("hide-buttons");
    };
  }, [hideButtonsBoolean]);

  // try {
  //   const test = window.top.location.href;
  //   //console.log('test',test);
  // } catch (err) {
  //   console.warn('SecurityError op window.top toegang:', err);
  // }

  const tempoUserPublisherID = urlParams.get("tempID");

  const [isWheelListenerAdded, setIsWheelListenerAdded] = useState(false);
  const [isKeydownListenerAdded, setIsKeydownListenerAdded] = useState(false);

  var reload = 9;

  let [extUserObject, setExtUserObject] = useState(null);

  let isAzerion = false;
  //Azerion^

  const [isMaxHeight, setIsMaxHeight] = useState(false);
  useEffect(() => {
    if (window.innerHeight <= 610) {
      setIsMaxHeight(true);
    } else {
      setIsMaxHeight(false);
    }
    const handleResize = () => {
      if (window.innerHeight <= 610) {
        setIsMaxHeight(true);
      } else {
        setIsMaxHeight(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  //let isCrazyGames = false;
  //CrazyGames

  if (isAzerion === true) {
    idString = "10000";
    publisherID = "aze";
    const deviceLanguage = navigator.language;
    const languageOnly = deviceLanguage.split("-")[0];
    langString = languageOnly;
  }

  useEffect(() => {
    if (isArkadium) {
      // idString = "10000";
      // publisherID = "ark";
      const deviceLanguage = "en";
      const languageOnly = deviceLanguage.split("-")[0];
      langString = languageOnly;


    }
  }, []);

  const publishersWithForum = [
    "forumTest",
    "forumtest",
    "today",
    "crz",
    "ark",
    "aze",
    "msn",
    "crz",
    "mng",
    "dpg",
    "dlt",
    "boo",
    "max"
  ];
    let forumEnabled = publishersWithForum.includes(publisherID);
  // let forumEnabled = true;
  if (forumEnabled === false) {
    forumEnabled = publishersWithForum.includes(publisherSubID);
  } 
  // else if (isGenius === true) {
  //   forumEnabled = false;
  // }

  const publishersWithGenius = [
    "geniusTest",
    "geniusDemo",
    "crz",
    "ark",
    "huf",
    "aze",
    "tri",
    // "mng",
    "usa",
    "usaPremium",
    "usaToday",
    "wapo",
    "wapoPremium",
    "erdee",
    "erdeePremium",
    "nik"
  ];

  let geniusEnabled = publishersWithGenius.includes(publisherID);
  if (geniusEnabled === false) {
    geniusEnabled = publishersWithGenius.includes(publisherSubID);
  }

  const publishersWithGeniusPurchase = ["geniusPurchaseTest"];
  let geniusPurchaseEnabled =
    publishersWithGeniusPurchase.includes(publisherID);
  if (geniusPurchaseEnabled === false) {
    geniusPurchaseEnabled = publishersWithGenius.includes(publisherSubID);
  }

  //useEffect(() => {

  if (idString === "10000") {
    if (yestBoolean === false) {
      //*********** TODAY ***********//

      if (isGenius === false) {
        idAsNumber = diffInDays;
      } else {
        // const rightToNumberOfGenius = extUserObject.get(
        //   "rightToNumberOfGenius"
        // );
        idAsNumber = Number(1);
        idAsNumber = Number(localStorage.getItem("lastSelectedGenius"));
      }

      classToBeLoaded = "ExtRiddle";
      isTodaysDayRiddle = true;
      isYesterdaysDayRiddle = false;
    } else {
      //*********** YESTERDAY ***********/

      if (isTodaysExplanationForPremium && isGenius === false) {
        idAsNumber = diffInDays;
      } else if (isGenius === true) {
        // const rightToNumberOfGenius = extUserObject.get(
        //   "rightToNumberOfGenius"
        // );
        // idAsNumber = -Number(rightToNumberOfGenius);
        idAsNumber = Number(1);
        idAsNumber = Number(localStorage.getItem("lastSelectedGenius"));
      } else {
        idAsNumber = diffInDays - 1;
      }

      classToBeLoaded = "ExtRiddle";
      isTodaysDayRiddle = false;
      isYesterdaysDayRiddle = true;
    }
  }

  //  else if (idString === "9999") {
  //   if (yestBoolean === false) {
  //     idAsNumber = diffInDays;
  //     classToBeLoaded = "Riddle";
  //     isTodaysDayRiddle = true;
  //     isYesterdaysDayRiddle = false;
  //   } else {
  //     idAsNumber = diffInDays - 1;
  //     classToBeLoaded = "Riddle";
  //     isTodaysDayRiddle = false;
  //     isYesterdaysDayRiddle = true;
  //   }
  // }

  //}, [idString, yestBoolean, diffInDays]);

  const [countDownTimer, setCountDownTimer] = useState("");

  const [changeHeader, setChangeHeader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isMenuModalOpen, setIsMenuModalOpen] = useState(false);
  const [isScoreModalOpen, setIsScoreModalOpen] = useState(false);
  const [isZoomModalOpen, setIsZoomModalOpen] = useState(false);
  const [isZoomCaseModal, setIsZoomCaseModal] = useState(false);
  const [isYesterdayAnswerModalOpen, setIsYesterdayAnswerModalOpen] =
    useState(false);
  const [dataFromChild, setDataFromChild] = useState(false);
  const [isIntroModalOpen, setIsIntroModalOpen] = useState(false);
  const [isLevelWarningModalOpen, setIsLevelWarningModalOpen] = useState(false);
  const [isAnswerModalOpen, setIsAnswerModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [result, setResult] = useState([]);
  const [resultYesterday, setResultYesterday] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingYesterday, setIsLoadingYesterday] = useState(false);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [isPuzzleModal, setIsPuzzleModal] = useState(false);
  const [puzzleCaseResponce, setPuzzleCaseResponce] = useState(null);
  const [isAnswerInputValue, setIsAnswerInputValue] = useState("");
  const [isAlreadyAnsweredBorder, setIsAlreadyAnsweredBorder] = useState(false);
  const [savedTime, setSaveTime] = useState("");
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(true);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [showTextCopied] = useState(false);
  let [numbersPlayed, setNumbersPlayed] = useState(0);
  let [won, setWon] = useState(0);
  let [lastPlayedMonth, setLastPlayedMonth] = useState(0);
  let [wonThisMonth, setWonThisMonth] = useState(0);
  let [wonMonthDate, setWonMonthDate] = useState(null);
  let [streak, setStreak] = useState(0);
  let [maxStreak, setMaxStreak] = useState(0);
  let [textToShareChallenge, setTextToShareChallenge] = useState(null);
  let [hasWonToday, setHasWonToday] = useState(false);
  const [getTopic, setGetTopic] = useState([]);
  const [hereURL, setHereURL] = useState(null);
  const [openGeniusModal, setOpenGeniusModal] = useState(false);
  const [openFaqModal, setOpenFaqModal] = useState(false);
  const [comment, setComment] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [formattedComments, setFormattedComments] = useState([]);

  // Keep "already played today" UI state in sync with localStorage (also after refresh).
  useEffect(() => {
    if (isGenius || tableView) return;
    if (yestBoolean) return; // only for today's challenge view

    try {
      const idsRaw = localStorage.playedIds;
      if (!idsRaw) {
        setChangeHeader(false);
        return;
      }
      const ids = JSON.parse(idsRaw);
      const exist = Array.isArray(ids) && ids.find((i) => i?.id === idAsNumber);
      setChangeHeader(!!exist);
    } catch (e) {
      setChangeHeader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idAsNumber, isGenius, tableView, yestBoolean]);

  const handleSubmitComment = () => {
    

    async function writeComments() {
      try {
        const CommentClass = Parse.Object.extend("ExtComment");
        const commentObject = new CommentClass();
        if (localStorage.username) {
          commentObject.set("userName", localStorage.username);
        } else {
          commentObject.set("userName", "Unknown");
        }

        commentObject.set("text", comment);
        var languageToSave = langString;
        // if (publisherID === "ark") {
        //   languageToSave = "ark"
        // }
        commentObject.set("language",languageToSave);

        switch (difficulty) {
          case "Too Easy":
            commentObject.set("rating", 0);
            break;
          case "Good":
            commentObject.set("rating", 1);
            break;
          case "Too Hard":
            commentObject.set("rating", 2);
            break;
        }

        // Save comment first
        const savedComment = await commentObject.save();

        // Now get riddle
        const Riddle = Parse.Object.extend("ExtRiddle");
        const tempQuery = new Parse.Query(Riddle);
        tempQuery.equalTo("extIdNumber", idAsNumber);
        const results = await tempQuery.find();

        const riddleObject = results[0];
        if (!riddleObject) {
          console.error("No riddle found.");
          return;
        }

        // Now it's safe to add a relation FROM savedComment TO riddleObject
        const relationComment = savedComment.relation("riddle");
        relationComment.add(riddleObject);
        await savedComment.save(); // Save again to store the relation

        await Parse.Cloud.run("linkCommentToRiddle", {
          riddleId: riddleObject.id,
          commentId: savedComment.id,
        });

        console.log("Riddle updated with comment pointer");

        setIsMenuModalOpen(true);
        setIsYesterdayAnswerModalOpen(true);
        setTimeout(() => {
          fetchRiddle();
        }, 1000);
      } catch (error) {
        console.error("Error writing comment:", error.message);
      }
    }

    //localStorage.removeItem("username");

    if (localStorage.username) {
      writeComments();
      setIsCommentModalOpen(false);
      setComment("");
      setDifficulty("");
    } else {
      setIsCommentModalOpen(false);
      setIsYesterdayAnswerModalOpen(false);
      setIsMenuModalOpen(false);

      Swal.fire({
        title: languageString.titleEnterName,
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
          spellcheck: "false",
        },
        showCancelButton: true,
        confirmButtonText: "OK",
        focusConfirm: false,
        customClass: {
          popup: "custom-popup",
          title: "custom-title",
          content: "custom-content",
          confirmButton: "custom-confirm-button",
        },
        didOpen: () => {
          const popup = document.querySelector(".swal2-popup");
          if (popup?.getAttribute("aria-hidden") === "true") {
            popup.removeAttribute("aria-hidden");
          }
          const input = document.querySelector(".swal2-input");
          if (input) {
            input.style.color = "black";
            input.style.backgroundColor = "white";

            input.style.border = "1px solid #ccc";
            input.style.padding = "0.5rem";
            input.style.borderRadius = "0.25rem";
            input.style.fontSize = "1rem";
            input.focus(); // Make sure focus is forced
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const name = result.value;
          if (name) {
            localStorage.username = name;
            writeComments();
            setIsCommentModalOpen(false);
            setComment("");
            setDifficulty("");
          }
        }
      });
    }
  };

  function isTodayModalOpen(setIsModalOpenValue) {
    setIsModalOpen(setIsModalOpenValue);

    // After the result modal: show today's answer explanation for everyone (non-genius).
    // Genius uses the same explanation modal with genius content (no "today's" flag).
    if (isGenius === false) {
      setYestBoolean(true);
      setIsYesterdayAnswerModalOpen(true);
      setIsTodaysExplanationForPremium(true);
    }

    if (isGenius === true) {
      setYestBoolean(true);
      setIsYesterdayAnswerModalOpen(true);
    }
  }

  const [languageString, setLanguageString] = useState({
    answerResultGoodTitle: "",
    answerResultWrongTitle: "",
    alreadyPlayedTitle: "",
    areYouSureTitle: "",
    yesTitle: "",
    noTitle: "",
    typeYourAnswerTitle: "",
    faq: "",

    titleYesterdaysAnswer: "",
    titleIntroduction: "",

    titlePlayed: "",
    titleWon: "",
    titleWonInMonth: "",
    titleStreak: "",
    titleMaxStreak: "",

    titleYesterday: "",

    titleExplanation: "",

    titleChallengeFriends: "",
  });

  const PARSE_APPLICATION_ID = "KsiVc1c1aAFXtHQzTt9dMVrSHHlT13DLPuVyESpG";
  const PARSE_HOST_URL = "https://parseapi.back4app.com/";
  const PARSE_JAVASCRIPT_KEY = "kgicXnMgIxLKHSLzNVhJglZ9BxuM31A4UUPrDgSz";
  Parse.initialize(PARSE_APPLICATION_ID, PARSE_JAVASCRIPT_KEY);
  Parse.serverURL = PARSE_HOST_URL;

  let userPublisherId;

  let correctAnswer = "Z";

  const setTheShareChallengeText = () => {
    switch (publisherID) {
      case "today": {
        setTextToShareChallenge(
          `🤓 Are you the smartest? 🤯\n💡 Play daily IQ challenges against your friends! 🏆\n🚀 Play SmartFriends by clicking this link: https://wwww.smartfriendsapp.com/today' 🚀`
        );

        break;
      }

      case "dpg": {
        setTextToShareChallenge(
          `🤓 Ben jij de slimste? 🤯\n💡 Speel dagelijks een IQ-challenge tegen je vrienden! 🏆\n🚀 Speel SmartFriends via deze link:`
        );

        break;
      }

      case "aze": {
        setTextToShareChallenge(
          `🤓 Are you the smartest? 🤯\n💡 Play daily IQ challenges against your friends! 🏆\n🚀 Are you joining?`
        );

        break;
      }

      case "msn": {
        setTextToShareChallenge(
          `🤓 Are you the smartest? 🤯\n💡 Play daily IQ challenges against your friends! 🏆\n🚀 Are you joining?`
        );

        break;
      }

      case "crz": {
        setTextToShareChallenge(
          `🤓 Are you the smartest? 🤯\n💡 Play daily IQ challenges against your friends! 🏆\n🚀 Play SmartFriends by clicking this link: https://www.crazygames.com/game/smartfriends-hoj`
        );

        break;
      }

      case "boo": {
        setTextToShareChallenge(
          `🤓 Think you're the smartest? 🤯\n💡 Play daily IQ challenges with your friends! 🏆\n🚀 Try SmartFriends now: https://www.seniorsguide.com/games/smartfriends-daily-puzzle`
        );

        break;
      }

      case "dlt": {
        setTextToShareChallenge(
          `🤓 Ben jij de slimste? 🤯\n💡 Speel dagelijks een IQ-uitdaging tegen je vrienden! 🏆\n🚀 Speel SmartFriends nu in de Leesland app!`
        );

        break;
      }
      case "max": {
        setTextToShareChallenge(
          `🤓 Ben jij de slimste? 🤯\n💡 Speel dagelijks een IQ-uitdaging tegen je vrienden! 🏆\n🚀 Speel SmartFriends bij MAX Magazine! https://maxmagazine.nl/smartfriends-online-puzzel/`
        );

        break;
      }
      case "ark": {
        setTextToShareChallenge(
           `🤓 Think you're the smartest? 🤯\n💡 Play daily IQ challenges with your friends. 🏆\n🚀 Try SmartFriends now!`
        );

        break;
      }

      default:
        setTextToShareChallenge(
          `🤓 Think you’re the smartest? 🤯\n💡Take on daily IQ challenges with your friends. 🏆\n🚀 Play SmartFriends now!`
        );
    }
  };

  const adjustTheScore = ({ isWon }) => {
    if (isGenius === false) {
      setHasWonToday(isWon);
    }

    if (isGenius === true) {
      extUserObject.increment("numberOfGeniusPlayed");
      extUserObject.addUnique("geniusPlayedArray", idAsNumber);
      extUserObject.save();
    }

    return () => {
      if (isGenius === false) {
        if (publisherID === "dpg") {
          PGSDK.gameCompleted();
        }

        if (publisherID === "ark") {
          async function lifeCycle() {
            await arksdk.lifecycle.onGameEnd();
            await arksdk.lifecycle.onChangeScore();
            await arksdk.lifecycle.onLevelEnd(parseInt(numbersPlayed, 10));
          }
          lifeCycle();
        }

        //numbersPlayed LOGEVENT
        let eventName = "numbersPlayed";
        if (publisherID) {
          eventName = `${eventName}.${publisherID}`;

          if (publisherSubID) {
            eventName = `${eventName}.${publisherSubID}`;
          }
        }

        amplitude.getInstance().logEvent(eventName, {
          parameter1: idAsNumber,
        });

        logEvent(analytics, eventName, {
          parameter1: idAsNumber,
        });

        numbersPlayed++;

        localStorage.numbersPlayed = Number(numbersPlayed);
        setNumbersPlayed(Number(localStorage.numbersPlayed));

        if (isWon === true) {
          won++;
          wonThisMonth++;

          logEvent(analytics, "resultGood", {
            parameter1: idAsNumber,
          });
        } else {
          logEvent(analytics, "resultWrong", {
            parameter1: idAsNumber,
          });
        }

        localStorage.won = Number(won);
        setWon(localStorage.won);

        localStorage.wonThisMonth = Number(wonThisMonth);
        setWonThisMonth(localStorage.wonThisMonth);

        const date = new Date();
        const currentMonth = date.getMonth() + 1;

        localStorage.lastPlayedMonth = Number(currentMonth);
        setLastPlayedMonth(localStorage.lastPlayedMonth);

        streak++;
        localStorage.streak = Number(streak);
        setStreak(Number(localStorage.streak));

        if (streak > maxStreak) {
          localStorage.maxStreak = Number(localStorage.streak);
          setMaxStreak(Number(localStorage.maxStreak));
        } else {
          setMaxStreak(Number(localStorage.maxStreak));
        }

        saveInParse(extUserObject);

        if (publisherID === "msn") {
          window.$msstart
            .submitGameResultsAsync(wonThisMonth)
            .then((result) => {
              // result will be true if result submitted successfully
              console.log("leaderboard result", result);
            });
        }
      }
    };
  };

  const saveInParse = () => {
    if (extUserObject) {
      extUserObject.set(
        "numberOfRiddlesPlayed",
        Number(localStorage.numbersPlayed)
      );
      extUserObject.set("numberOfRiddlesWon", Number(localStorage.won));
      extUserObject.set("currentStreak", Number(localStorage.streak));
      extUserObject.set("maxStreak", Number(localStorage.maxStreak));
      extUserObject.set("wonThisMonth", Number(localStorage.wonThisMonth));

      let array = extUserObject.get("playedIds");
      array.push(idAsNumber);

      extUserObject.set("playedIds", array);
      extUserObject.save();
    }
  };

  // check the user selected value if it's same as answer
  // if correct, show success dialog else, failed dialog by setting isSuccess = true or false
  const handleDecisionClick = (e, indicator) => {
    console.log("handleDecisionClick");

    //stopTimer();
    let ind = indicator || selectedIndicator;
    setIsAlreadyAnsweredBorder(false);
    setIsConfirmModalOpen(false);
    setSelectedIndicator(null);
    let extAnswer = "";
    let extAnswerArray = [""];

    if (ind) {
      if (ind === window.correctAnswer) {
        setIsSuccess(true);
        if (localStorage.playedIds) {
          const ids = JSON.parse(localStorage.playedIds);
          const exist = ids.find((i) => i.id === idAsNumber);
          if (!exist) {
            adjustTheScore({ isWon: true })();
          }
        } else {
          adjustTheScore({ isWon: true })();
        }
        extAnswer = "extAnswerGood";
        extAnswerArray = "extAnswerGoodArray";
      } else {
        setIsSuccess(false);
        if (localStorage.playedIds) {
          const ids = JSON.parse(localStorage.playedIds);
          const exist = ids.find((i) => i.id === idAsNumber);
          if (!exist) {
            adjustTheScore({ isWon: false })();
          }
        } else {
          adjustTheScore({ isWon: false })();
        }
        extAnswer = "extAnswerWrong";
        extAnswerArray = "extAnswerWrongArray";
      }
    } else {
      setIsPuzzleModal(true);

      const normalizedOpenInput = isAnswerInputValue.trim().toLowerCase();
      const puzzleCase = result.attributes?.correctOpenAnswer.find(
        (i) =>
          i != null &&
          String(i).trim().toLowerCase() === normalizedOpenInput
      );

      setPuzzleCaseResponce(result.attributes?.correctOpenAnswer[0]);

      if (puzzleCase) {
        setIsSuccess(true);
        if (localStorage.playedIds) {
          const ids = JSON.parse(localStorage.playedIds);
          const exist = ids.find((i) => i.id === idAsNumber);
          if (!exist) {
            adjustTheScore({ isWon: true })();
          }
        } else {
          adjustTheScore({ isWon: true })();
        }
        extAnswer = "extAnswerGood";
        extAnswerArray = "extAnswerGoodArray";
      } else {
        setIsSuccess(false);
        if (localStorage.playedIds) {
          const ids = JSON.parse(localStorage.playedIds);
          const exist = ids.find((i) => i.id === idAsNumber);
          if (!exist) {
            adjustTheScore({ isWon: false })();
          }
        } else {
          adjustTheScore({ isWon: false })();
        }

        extAnswer = "extAnswerWrong";
        extAnswerArray = "extAnswerWrongArray";
      }
    }

    const query = new Parse.Query(classToBeLoaded);

    if (isTodaysDayRiddle === true) {
      // const fromDate = new Date(2022, 0, 1); // January is month 0
      // const currentDate = new Date();
      // const timeDiff = currentDate.getTime() - fromDate.getTime();
      // const diffInDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

      if (isGenius === false) {
        idAsNumber = diffInDays;
      }

      if (classToBeLoaded === "ExtRiddle") {
        query.equalTo("extIdNumber", idAsNumber);
      } else {
        query.equalTo("idNumber", idAsNumber);
      }
    } else {
      query.equalTo("extIdNumber", idAsNumber);
    }

    if (alreadyPlayed === false) {
      switch (extAnswer) {
        case "extAnswerGood":
          if (publisherID !== "today" && publisherID) {
            Parse.Cloud.run("updateGood", {
              extIdNumber: idAsNumber,
              publisherId: publisherID,
            })
              .then((result) => {
                console.log("Cloud Update successful good");
              })
              .catch((error) => {
                console.error("Cloud Error updating:", error);
              });
          }

          break;

        case "extAnswerWrong":
          if (publisherID !== "today" && publisherID) {
            Parse.Cloud.run("updateWrong", {
              extIdNumber: idAsNumber,
              publisherId: publisherID,
            })
              .then((result) => {
                console.log("Cloud Update successful wrong");
              })
              .catch((error) => {
                console.error("Cloud Error updating:", error);
              });
          }

          break;

        default:
          break;
      }

      if (publisherID === "crz" && numbersPlayed <= adTriggerSolution) {
        if (extAnswer === "extAnswerGood") {
          window.CrazyGames.SDK.game.happytime();
        }
      }

      else if (publisherID === "ark" && isGenius === false) {
          async function handleArkadiumAdsIfNeeded() {
             // numbersPlayed = Number(35);

            if (numbersPlayed > adTriggerSolution) {
              const isAuthorized = await arksdk.auth.isUserAuthorized();

              if (isAuthorized) {
                const profile = await arksdk.auth.getUserProfile();

                  if (profile.isUserSubscriber) {
                    //does have profile, AND a subscription
                    console.log("Arkadium, profile + subscription");
                    setIsModalOpen(true);
                  } else {
                    //does have profile, but no subscription
                    showAdIfNeeded();
                    console.log("Arkadium, profile, NO subscription");
                  }
              } else {
                //does NOT have profile
                showAdIfNeeded();
                console.log("Arkadium, NO profile, NO subscription");
              }

              async function showAdIfNeeded() {
                const isEven = (n) => n % 2 === 0;
                if (parseInt(numbersPlayed, 10) < 30) {
                  
                  if (isEven(numbersPlayed) && arksdk.ads.showInterstitialAd) {
                    await arksdk.ads.showInterstitialAd();
                    console.log("Interstitial finished! A");
                      setIsModalOpen(true);
                 
                  }else{
                     setIsModalOpen(true);
                  }

                } else {
                  if (arksdk.ads.showInterstitialAd) {
                    await arksdk.ads.showInterstitialAd();
                    console.log("Interstitial finished! B");
                      setIsModalOpen(true);
                 
                  }else{
                    setIsModalOpen(true);
                  }
          
                }
              }
            }else{
                setIsModalOpen(true);
            }
          }
          handleArkadiumAdsIfNeeded();
        }

        else if (publisherID === "crz" && numbersPlayed > adTriggerSolution) {
          const callbacks = {
            adFinished: () => {
              console.log("End midgame ad");
              if (extAnswer === "extAnswerGood") {
                window.CrazyGames.SDK.game.happytime();
              }
            },
            adError: (error) => console.log("Error midgame ad", error),
            adStarted: () => console.log("Start midgame ad"),
          };
          window.CrazyGames.SDK.ad.requestAd("midgame", callbacks);

          setTimeout(() => {
            // open dialog
            setIsModalOpen(true);
          }, 1000);
        } 
        
        
        else {
          setIsModalOpen(true);
          console.log("no need to show ad")
        }
    }

    // query
    //   .find()
    //   .then((response) => {

    //    // response[0].increment(extAnswer);
    //     // if (publisherID !== null) {
    //     //   response[0].add(extAnswerArray, publisherID);
    //     // }
    //     // response[0].save();
    //   })
    //   .catch((err) => {
    //     console.log("error position 2 = ", err);
    //   });

    if (
      typeof window.gdsdk !== "undefined" &&
      window.gdsdk.showAd !== "undefined" &&
      isAzerion === true
    ) {
      window.gdsdk.showAd();
      setTimeout(() => {
        // open dialog
        setIsModalOpen(true);
      }, 1000);
    } 

    if (localStorage.playedIds) {
      const ids = JSON.parse(localStorage.playedIds);
      const exist = ids.find((i) => i.id === idAsNumber);

      if (!exist) {
        ids.push({
          id: idAsNumber,
          selectedValue: ind || isAnswerInputValue.trim(),
          date: formatDate(),
          solvedIn: formatTime(extAnswer),
          solvedDate: new Date(),
        });

        //opheffen??
        localStorage.playedIds = JSON.stringify(ids);
        localStorage.numbersPlayed = ids.length;
        // setNumbersPlayed(localStorage.numbersPlayed);

        if (isGenius === false) {
          setSaveTime({
            id: idAsNumber,
            selectedValue: ind || isAnswerInputValue.trim(),
            date: formatDate(),
            solvedIn: formatTime(extAnswer),
            solvedDate: new Date(),
          });
        }
        setChangeHeader(false);
      } else {
        if (isGenius === false) {
          setSaveTime(exist);
        }
        setChangeHeader(true);
      }
    } else {
      localStorage.playedIds = JSON.stringify([
        {
          id: idAsNumber,
          selectedValue: ind || isAnswerInputValue.trim(),
          date: formatDate(),
          solvedIn: formatTime(extAnswer),
          solvedDate: new Date(),
        },
      ]);

      //opheffen?
      localStorage.numbersPlayed =
        JSON.parse(localStorage.playedIds)?.length || 0;
      // setNumbersPlayed(localStorage.numbersPlayed);

      if (isGenius === false) {
        setSaveTime({
          id: idAsNumber,
          selectedValue: ind || isAnswerInputValue.trim(),
          date: formatDate(),
          solvedIn: formatTime(extAnswer),
          solvedDate: new Date(),
        });
      }
    }
    setAlreadyPlayed(true);
    
  };

  const handleAnswerClick = (indicator) => {
    // if (isYesterdaysDayRiddle === true) {
    //   handleWidgetClick();
    //   return;
    // }


    if (
      !localStorage.playedIds ||
      (localStorage.playedIds &&
        !JSON.parse(localStorage.playedIds).find((i) => i.id === idAsNumber))
    ) {
      setIsConfirmModalOpen(true);
      setSelectedIndicator(indicator);
      setIsAlreadyAnsweredBorder(true);

      console.log("Modal: NOT played yet", alreadyPlayed);
    } else {
      handleDecisionClick(null, indicator);
      console.log("Modal: played already", alreadyPlayed);
      setIsModalOpen(true);
    }
  };

  const handleOpenAnswerClick = () => {
    if (localStorage.playedIds) {
      const ids = JSON.parse(localStorage.playedIds);
      const exist = ids.find((i) => i.id === idAsNumber);

      if (exist) {
        setIsModalOpen(true);
        setChangeHeader(true);
      }
    }
  };

  const handleCancelClick = () => {
    setIsConfirmModalOpen(false);
    setIsAlreadyAnsweredBorder(false);
    setIsMenuModalOpen(false);
  };

  const handleYesterdayAnswerClose = () => {
    setTimeout(() => {
      window.DiscourseEmbed = null;
    }, 1500);

    setIsYesterdayAnswerModalOpen(false);
    setYestBoolean(false);

    setIsPuzzleModal(false);
    setFormattedComments([]);
    // Intro backdrop (first play or premium): after closing the answer explanation
    if (
      !hideButtonsBoolean &&
      isTodaysExplanationForPremium &&
      isGenius === false &&
      (isPremium || numbersPlayed === 1)
    ) {
      setIsIntroPopupOpen(true);
    }

    setIsTodaysExplanationForPremium(false);

    logEvent(analytics, "yesterdayAnswerShown", {});
  };
  const handleGeniusModalClose = () => {
    setTimeout(() => {
      window.DiscourseEmbed = null;
    }, 1500);
    setOpenGeniusModal(false);
  };

  const handleFaqModalClose = () => {
    setTimeout(() => {
      window.DiscourseEmbed = null;
    }, 1500);
    setOpenFaqModal(false);
  };

  const getGeniusChallenge = () => {
    console.log("getGeniusChallenge");
  };

  const handleWebModalClose = () => {
    setDataFromChild(false);
  };

  const handleIntroModalClose = () => {
    setIsIntroModalOpen(false);
  };
  const handleZoomModalClose = () => {
    setIsZoomModalOpen(false);
  };

  const handleTypeAnswerModalClose = () => {
    setIsAnswerModalOpen(false);
  };
  const handleScoreModalClose = () => {
    setIsScoreModalOpen(false);
  };

  useEffect(() => {
    setTimeout(function () {
      console.log("Playing registered.", userPublisherId);

      let eventName = "played10seconds";
      if (publisherID) {
        eventName = `${eventName}.${publisherID}`;
      }

      amplitude.getInstance().logEvent(eventName, {
        parameter1: idAsNumber,
      });
      logEvent(analytics, eventName, {
        parameter1: idAsNumber,
      });

      //WITHOUT PUBLISHERID
      amplitude.getInstance().logEvent("played10seconds");
      logEvent(analytics, "played10seconds", {});
    }, 10000);
  }, []);

  useEffect(() => {
    setTheShareChallengeText();

    if (langString === "nl") {
      setLanguageString({
        answerResultGoodTitle: "Goed gedaan!",
        answerResultWrongTitle: "Volgende keer beter...",
        alreadyPlayedTitle: "Al gespeeld",
        areYouSureTitle: "Weet je het zeker?",
        yesTitle: "Ja",
        noTitle: "Nee",
        faq: "Veelgestelde Vragen",
        typeYourAnswerTitle: "typ je antwoord",

        titleYesterdaysAnswer: "Uitleg van gisteren",
        titleTodaysAnswer: "Uitleg van vandaag",
        titleIntroduction: "Introductie",

        titlePlayed: "gespeeld",
        titleWon: "gewonnen",
        titleWonInMonth: "gewonnen in",
        titleStreak: "reeks",
        titleMaxStreak: "max reeks",

        titleYesterday: "Gisteren",

        titleExplanation: "Uitleg",

        titleChallengeFriends: "daag vrienden uit",
        titleEnterName: "Vul je naam in:",
      });
    } else {
      
      setLanguageString({
        answerResultGoodTitle: "Well done!",
        answerResultWrongTitle: "Better luck tomorrow...",
        answerGeniusResultWrongTitle: "Better luck next time...",
        alreadyPlayedTitle: "Already played",
        areYouSureTitle: "Are you sure?",
        yesTitle: "Yes",
        noTitle: "No",
        typeYourAnswerTitle: "type your answer",
        faq: "Frequently Asked Questions",

        titleYesterdaysAnswer: "Yesterday's answer",
        titleTodaysAnswer: "Today's explanation",
        titleIntroduction: "Introduction",

        titlePlayed: "played",
        titleWon: "won",
        titleWonInMonth: "won in",
        titleStreak: "streak",
        titleMaxStreak: "max streak",

        titleYesterday: "Yesterday",

        titleExplanation: "Explanation",

        titleChallengeFriends: "challenge friends",
        titleEnterName: "Enter your name:",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (publisherID === "crz") {
      if (
        tableView === false &&
        isYesterdayAnswerModalOpen === false &&
        isModalOpen === false &&
        openFaqModal === false &&
        result.attributes?.questionImage !== undefined
      ) {
        // console.log('Preventing scroll');

        // Add wheel listener if not already added
        if (!isWheelListenerAdded) {
          window.addEventListener("wheel", preventScrollWheel, {
            passive: false,
          });
          setIsWheelListenerAdded(true);
        }

        // Add keydown listener if not already added
        if (!isKeydownListenerAdded) {
          window.addEventListener("keydown", preventScrollKeydown);
          setIsKeydownListenerAdded(true);
        }
      } else {
        //console.log('NOT preventing scroll');

        // Remove wheel listener if it was added
        if (isWheelListenerAdded) {
          window.removeEventListener("wheel", preventScrollWheel, {
            passive: false,
          });
          setIsWheelListenerAdded(false);
        }

        // Remove keydown listener if it was added
        if (isKeydownListenerAdded) {
          window.removeEventListener("keydown", preventScrollKeydown);
          setIsKeydownListenerAdded(false);
        }
      }
    }
  }, [
    tableView,
    isYesterdayAnswerModalOpen,
    isModalOpen,
    openFaqModal,
    result.attributes?.questionImage,
  ]);



  useEffect(() => {

    //localStorage.removeItem("userPublisherId");
    //Als userPublisherId nog niet bestaat: creeer een randon one.

    //moet dit weg?
    // if (publisherID === "ark") {
    //   async function checkForArkadiumData() {
    //     const item =
    //       await arksdk.persistence.getLocalStorageItem("userPublisherId");
    //     if (item && item !== "undefined") {
    //       localStorage.userPublisherId = item;
    //       userPublisherId = item;
    //     }
    //   }
    //   checkForArkadiumData();
    // }

    if (
      !localStorage.getItem("userPublisherId") &&
      ( publisherID === "today" ||
        publisherID === "ark" ||
        publisherID === "huf" ||
        publisherID === "aze" ||
        publisherID === "tri" ||
        publisherID === "mng" ||
        publisherID === "geniusDemo" ||
        publisherID === "usa" ||
        publisherID === "usaPremium" ||
        publisherID === "usaToday" ||
        publisherID === "wapo" ||
        publisherID === "wapoPremium" ||
        publisherID === "erdee" ||
        publisherID === "erdeePremium" ||
        publisherID === "dlt")
    ) {
      if (publisherID === "ark") {
        async function checkUserAuthorization() {
          try {
          
            const isAuthorized = await arksdk.auth.isUserAuthorized();

            if (isAuthorized) {
              const profile = await arksdk.auth.getUserProfile();
              console.log("Arkadium User is authorized.",profile.avatar);
              

              if (profile) {
                userPublisherId = profile.uid;
                localStorage.username = profile.username;
                localStorage.setItem("userPublisherId", userPublisherId);
                await arksdk.persistence.setLocalStorageItem("userPublisherId",userPublisherId);
            
                console.log(" My userPublisherId", userPublisherId);
                setToCurrentExtUserOrCreate(userPublisherId);

                console.log(
                  "ARKADIUM USER profile:",
                  localStorage.userPublisherId);

                       
                };
            } else {
              console.log("Arkadium User is not authorized.");
              userPublisherId =
                publisherID + Math.floor(Math.random() * 100000000000000);
                localStorage.setItem("userPublisherId", userPublisherId);
                await arksdk.persistence.setLocalStorageItem("userPublisherId",userPublisherId);
                console.log(" My userPublisherId", userPublisherId);
                setToCurrentExtUserOrCreate(userPublisherId);
            }
          } catch (error) {
            console.error("Arkadium User Authorization check failed:", error);
            userPublisherId =
              publisherID + Math.floor(Math.random() * 100000000000000);
            localStorage.setItem("userPublisherId", userPublisherId);
            await arksdk.persistence.setLocalStorageItem("userPublisherId",userPublisherId);
            console.log(" My userPublisherId", userPublisherId);
            setToCurrentExtUserOrCreate(userPublisherId);
          }
        }

        checkUserAuthorization();
      } else {
        console.log("set random userID");
        userPublisherId =
          publisherID + Math.floor(Math.random() * 100000000000000);
        localStorage.setItem("userPublisherId", userPublisherId);
        console.log(" My userPublisherId", userPublisherId);
        setToCurrentExtUserOrCreate(userPublisherId);
      }
    }

    if (publisherID === "crz") {
      async function initializeCrazyGames() {
        try {
          // Wait for the CrazyGames SDK to initialize
          await window.CrazyGames.SDK.init();

          window.CrazyGames.SDK.game.gameplayStart();

          // This will run when the initialization is complete
          console.log("CrazyGames SDK initialized successfully!");

          window.CrazyGames.SDK.user
            .getUser()
            .then(async (user) => {
              console.log("Crazygame user:", user);
              console.log("Crazygame username:", user["username"]);

              try {
                if (window.CrazyGames.SDK.data.getItem("userPublisherId")) {
                  userPublisherId =
                    window.CrazyGames.SDK.data.getItem("userPublisherId");
                } else {
                  userPublisherId =
                    user["username"] +
                    Math.floor(Math.random() * 100000000000000);
                  window.CrazyGames.SDK.data.setItem(
                    "userPublisherId",
                    userPublisherId
                  );
                }

                localStorage.setItem("userPublisherId", userPublisherId);
                setToCurrentExtUserOrCreate(userPublisherId);

                if (publisherID === "crz") {
                  window.CrazyGames.SDK.game.loadingStart();
                }
              } catch (e) {
                console.log("token Error:", e);
              }
            })
            .catch((e) => {
              console.log("Get user error: ", e);

              if (window.CrazyGames.SDK.data.getItem("userPublisherId")) {
                userPublisherId =
                  window.CrazyGames.SDK.data.getItem("userPublisherId");
              } else {
                userPublisherId =
                  "GuestCRZ" + Math.floor(Math.random() * 100000000000000);
                window.CrazyGames.SDK.data.setItem(
                  "userPublisherId",
                  userPublisherId
                );
              }

              localStorage.setItem("userPublisherId", userPublisherId);
              setToCurrentExtUserOrCreate(userPublisherId);
            });
        } catch (error) {
          console.error("Failed to initialize CrazyGames SDK:", error);
        }
      }
      initializeCrazyGames();
    }
  }, []);

  //   async function getIPAddress() {
  //     try {
  //       const response = await fetch('https://api.ipify.org?format=json');
  //       const data = await response.json();
  //       console.log('data ip address',data.ip);
  //       return data.ip; // Returns the user's IP address
  //     } catch (error) {
  //       console.error("Error fetching IP address:", error);
  //       return null;
  //     }
  //   }

  //   useEffect(() => {
  //   getIPAddress();
  // }, []);

  useEffect(() => {
    amplitude.getInstance().init("842d48b4880b491c7809820741a54e76", null, {
      serverZone: "EU",
      serverZoneBasedApi: true,
    });

    if (publisherID === "dpg") {
      PGSDK.gameStarted();
    }
    if (publisherID === "ark") {
      async function lifeCycle() {
        await arksdk.lifecycle.onGameStart();
     
        await arksdk.lifecycle.onLevelStart(parseInt(numbersPlayed, 10)+1);
      }
      lifeCycle();
    }

    if (publisherID !== "today" && publisherID) {
      let mustLogLoaded = true;

      if (localStorage.loadedIds) {
        let loadedIds = JSON.parse(localStorage.getItem("loadedIds")) || [];
        let loadedIdAlreadyLogged = loadedIds.includes(idAsNumber);

        if (loadedIdAlreadyLogged === true) {
          mustLogLoaded = false;
        } else {
          let loadedIds = JSON.parse(localStorage.getItem("loadedIds")) || [];
          loadedIds.push(idAsNumber);
          localStorage.setItem("loadedIds", JSON.stringify(loadedIds));
        }
      } else {
      
        let loadedIds = JSON.parse(localStorage.getItem("loadedIds")) || [];
        loadedIds.push(idAsNumber);
        localStorage.setItem("loadedIds", JSON.stringify(loadedIds));
      }

      if (mustLogLoaded) {
       
        amplitude.getInstance().logEvent("loaded", {
          extIdNumber: idAsNumber,
          publisherId: publisherID,
        });

        //AFTER 15 SECONDS DELAY-----:
        setTimeout(function () {
          console.log("Playing unique 15 sec registered.",idAsNumber);

          Parse.Cloud.run("updateLoaded", {
            extIdNumber: idAsNumber,
            publisherId: publisherID,
          })
            .then((result) => {
              console.log("Cloud Update successful");
            })
            .catch((error) => {
              console.error("Cloud Error updating:", error);
            });

          let eventName = "played10secondsUnique";
          if (publisherID) {
            eventName = `${eventName}.${publisherID}`;
          }

          amplitude.getInstance().logEvent(eventName, {
            parameter1: idAsNumber,
          });

          logEvent(analytics, eventName, {
            parameter1: idAsNumber,
          });

          if (publisherID === "usa" || publisherID === "usaPremium") {
            let savedPublisherId = extUserObject.get("publisherId");
            console.log("currentPublisherId", publisherID);
            console.log("savedPublisherId", savedPublisherId);

            switch (publisherID) {
              case "usa":
                if (savedPublisherId === "usaPremium") {
                  //USER CHANGED TO NON-PREMIUM
                  extUserObject.set("publisherId", publisherID);
                  extUserObject.save();
                  console.log("USER CHANGED TO NON-PREMIUM");
                }
                break;

              case "usaPremium":
                if (savedPublisherId === "usa") {
                  //USER CHANGED TO PREMIUM
                  extUserObject.set("publisherId", publisherID);
                  extUserObject.save();
                  console.log("USER CHANGED TO PREMIUM");

                  amplitude.getInstance().logEvent("changedToPremium");
                  logEvent(analytics, "changedToPremium", {});
                }

                break;

              default:
                // console.log("Default case triggered");
                break;
            }

            //save played10secondsUnique to user
            extUserObject.addUnique("played10secondsUnique", idAsNumber);
            extUserObject.save();
            console.log("played10secondsUnique saved in user");
          }

          //WITHOUT PUBLISHERID
          amplitude.getInstance().logEvent("played10secondsUnique");
          logEvent(analytics, "played10secondsUnique", {});
        }, 10000);
      }
    }
  }, []);

  useEffect(() => {
    fetchRiddle();
  }, [correctAnswer, yestBoolean]);

  const fetchRiddle = () => {
    console.log("fetchRiddle:",idAsNumber);

    if (idAsNumber === 10000) {
     
      return;
    }

    if ((!yestBoolean && !isMenuModalOpen && isGenius === true) || tableView) {
     
      setIsLoading(true);
    } else {
      setIsLoadingYesterday(true);
    }

    const query = new Parse.Query(classToBeLoaded);
    if (classToBeLoaded === "ExtRiddle") {
      query.equalTo("extIdNumber", idAsNumber);
    } else {
      query.equalTo("idNumber", idAsNumber);
    }

    query
      .find()
      .then(function (response) {
        if (response.length === 0) {
          //-----BACK UP MODE------
          console.log("Object not found...", idAsNumber, response);
          var currentDate = new Date();
          var dayNumber = currentDate.getDate();

          idAsNumber = dayNumber;

          if (yestBoolean) {
            idAsNumber = dayNumber - 1;
          }

          fetchRiddle();
          //------------------
        } else {
          setIsLoading(false);
          setIsLoadingYesterday(false);

          if (!yestBoolean) {
            setResult(response[0]);
          } else {
            setResultYesterday(response[0]);
            loadComments(idAsNumber);
         
          }

          // response[0].increment("loaded");
          // if (publisherID !== null) {
          //   response[0].add("loadedArray", publisherID);
          // }
          // response[0].save();

          const type = response[0].get("type");
          if (type !== "openAnswer") {
            window.correctAnswer = response[0].get("correctAnswer");
          } else {
            window.correctAnswer = response[0].get("correctOpenAnswer")[0];
            setPuzzleCaseResponce(response[0].get("correctOpenAnswer")[0]);
            let isExist = JSON.parse(localStorage.playedIds).find(
              (i) => i.id === idAsNumber
            );

            if (isExist) {
              if (isGenius === false) {
                setSaveTime(isExist);
              }
              setIsPuzzleModal(true);

              const userOpenNorm = (isExist?.selectedValue ?? "")
                .trim()
                .toLowerCase();
              const correctOpenAnswers =
                response[0].get("correctOpenAnswer") || [];
              const isOpenAnswerCorrect = correctOpenAnswers.some(
                (a) =>
                  a != null &&
                  String(a).trim().toLowerCase() === userOpenNorm
              );
              if (isOpenAnswerCorrect) {
                setIsSuccess(true);
              } else {
                setIsAnswerInputValue(isExist.selectedValue);
              }
            }
          }
        }
      })
      .catch((error) => {
        if (error.code === Parse.Error.OBJECT_NOT_FOUND) {
          //-----BACK UP MODE------
          console.log("Object not found .catch");
          var currentDate = new Date();
          var dayNumber = currentDate.getDate();

          idAsNumber = dayNumber;

          if (yestBoolean) {
            idAsNumber = dayNumber - 1;
          }

          fetchRiddle();
          //------------------
        } else {
          // Other error, handle accordingly
          console.log("Fetch error:", error.message);
          console.log("Fetch error:", error.code);
        }
      });
  };

  async function loadComments(idAsNumber) {
    try {
    

      const Riddle = Parse.Object.extend("ExtRiddle");
      const tempQuery = new Parse.Query(Riddle);
      tempQuery.equalTo("extIdNumber", idAsNumber);
      const results = await tempQuery.find();

      const object = results[0];
      var relation = object.get("commentRelations3");
      var relationQuery = relation.query();
      
      //***********************/
      //DEACTIVATED!!!!
      //ARKADIUM USER CAN ONLY SEE ARKADIUM COMMENTS
      //ENGLISH USERS CAN SEE ALL ENGLISH AND ALL ARKADIUM COMMENTS
      //OTHER LANGUAGES CAN ONLY SEE THEIR OWN LANGUAGE COMMENTS
      var languageToFetch = langString;
      // if (publisherID === "ark") {
      //   languageToFetch = "ark" 
      // }
    
      // if (langString === "en" && publisherID != "ark") {
      //   relationQuery.containedIn("language", ["ark", "en"]);
      // }
      // else{
          relationQuery.equalTo("language", languageToFetch);
     // }
      //***********************/
       
      relationQuery.descending("createdAt");
      const commentsArray = await relationQuery.find();
      setFormattedComments(
        commentsArray.map((comment, index) => ({
          id: index + 1,
          parseObjectId: comment.id,
          avatar: comment.get("profileImage")?.url() || avatar,
          username: comment.get("userName") || "Anonymous",
          text: comment.get("text") || "",
          difficulty: comment.get("rating"),
          likes: comment.get("likes") || [], 
        })) || []
      );
    } catch (error) {
      console.error("Comments error:", error);
    }
  }

  /*
 // Create a query to fetch ExtRiddle objects
            const ExtRiddle = Parse.Object.extend("ExtRiddle");
            const query = new Parse.Query(ExtRiddle);
            
            // Apply a constraint to the query
            query.equalTo("extIdNumber", extIdNumber);

            // Perform the query
            query.find()
                .then(function(results) {
                    console.log('Results:', results);
                    if (results.length === 0) {
                        console.log("Object not found.");
                        alert("Uh oh, we couldn't find the object!");
                    } else {
                        alert('Data retrieved successfully: ' + JSON.stringify(results));
                    }
                })
                .catch(function(error) {
                    console.error('Error:', error);
                    if (error.code === Parse.Error.OBJECT_NOT_FOUND) {
                        alert("Uh oh, we couldn't find the object!");
                    } else {
                        alert('An error occurred while retrieving data: ' + error.message);
                    }
                });
        });



  */

  useEffect(() => {
    if (isRunning) {
      const timerInterval = setInterval(() => {
        setTime((prevTime) => prevTime + 1);

        //changed
        updateCountdown();
      }, 1000);

      return () => {
        clearInterval(timerInterval);
      };
    }
  }, [isRunning]);

  const stopTimer = () => {
    setIsRunning(false);
  };

  const formatTime = (answer) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    const format = (num) => (num < 10 ? `0${num}` : num);

    if (langString === "nl") {
      if (answer === "extAnswerGood") {
        return `Tijd: ${format(hours) + "."}${format(minutes) + "."}${format(
          seconds
        )}`;
      } else {
        return ""; // Not solved
      }
    } else {
      if (answer === "extAnswerGood") {
        return `Time: ${format(hours) + "."}${format(minutes) + "."}${format(
          seconds
        )}`;
      } else {
        return ""; // Not solved
      }
    }
  };

  const formatDate = () => {
    const options = { day: "numeric", month: "long" }; //weekday: 'long',
    if (langString === "nl") {
      return new Date().toLocaleDateString("nl", options);
    } else {
      return new Date().toLocaleDateString("en", options);
    }
  };
  const WidgetHeaderDate = () => {
    if (isGenius || tableView) {
      return ``;
    }

    if (isGenius) {
      return ``;
    }
    const date = new Date();

    if (langString === "nl") {
      const month = date.toLocaleString("nl-NL", { month: "long" });
      const day = date.toLocaleString("nl-NL", { day: "numeric" });

      return `${day} ${month}`;
    } else {
      const month = date.toLocaleString("en-EN", { month: "long" });
      const day = date.toLocaleString("en-EN", { day: "numeric" });

      return `${month} ${day}`;
    }
  };

  const handleWidgetClick = () => {
    if (isYesterdaysDayRiddle) {
      setChangeHeader(true);
   
      setIsModalOpen(true);
    }
  };

  const handleZoomClick = () => {
    if (hideButtonsBoolean) {
      return;
    }
    if (
      result.attributes?.questionImageNL ||
      result.attributes?.questionImage
    ) {
      setIsZoomModalOpen(true);
    }
  };

  const handleShareResultGoodClick = async () => {
    logEvent(analytics, "shareResultButtonClicked", {});

    const date = new Date();
    const month = date.toLocaleString("en-EN", { month: "long" });
    let textToShareResult = "";

    textToShareResult = `🤓 SmartFriends\n🗓️ ${savedTime?.date} ✅\n💡 ${savedTime?.solvedIn} \n🏆 Won in ${month}: ${wonThisMonth}\n🤯Are you smarter?`;

    if (langString === "nl") {
      const month = date.toLocaleString("nl-NL", { month: "long" });
      textToShareResult = `🤓 SmartFriends\n🗓️ ${savedTime?.date} ✅\n💡 ${savedTime?.solvedIn} \n🏆 Gewonnen in ${month}: ${wonThisMonth}\n🤯Ben jij slimmer?`;
    }

    if (publisherID === "dpg") {
      const date = new Date();
      const month = date.toLocaleString("nl-NL", { month: "long" });
      textToShareResult = `🤓 SmartFriends\n🗓️ ${savedTime?.date} ✅\n💡 ${savedTime?.solvedIn}\n🏆 Gewonnen in ${month}: ${wonThisMonth}\n🤯 Ben jij slimmer?`;

      PGSDK.gameShare({
        text: textToShareResult,
      });
    } else if (!navigator.share) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(textToShareResult)
          .then(function () {
            window.Swal.fire({
              title: langString === "nl" ? "Gekopieerd!" : "Copied!",
              html:
                (langString === "nl" ? "Deze tekst is naar je klembord gekopieerd,<br>deel het met vrienden!<br><br>" : "This text is copied to your clipboard,<br>share it with friends!<br><br>") +
                textToShareResult.replace(/\n/g, "<br>"),
              icon: "success",
              confirmButtonText: "OK",
              allowEnterKey: true,
              customClass: {
                popup: "custom-popup",
                title: "custom-title",
                content: "custom-content",
                confirmButton: "custom-confirm-button",
              },
            });
          })
          .catch(function (err) {
            console.error("Could not copy text: ", err);
            window.Swal.fire({
              title: langString === "nl" ? "Kopieer deze tekst en deel het met vrienden!" : "Copy this text and share it with friends!",
              html: textToShareResult.replace(/\n/g, "<br>"),
              text: textToShareResult.replace(/\n/g, "<br>"),
              confirmButtonText: "OK",
              allowEnterKey: true,

              customClass: {
                popup: "custom-popup",
                title: "custom-title",
                content: "custom-content",
                confirmButton: "custom-confirm-button",
                allowEnterKey: true,
              },
            });
          });
      }
    } else if (navigator.share) {
      await navigator
        .share({
          // title: "Share your score!",
          text: textToShareResult,
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => {
          console.error("Error sharing:", error.code);

          if (error.code !== 20 && navigator.clipboard) {
            navigator.clipboard
              .writeText(textToShareResult)
              .then(function () {
                window.Swal.fire({
                  title: langString === "nl" ? "Gekopieerd!" : "Copied!",
                  html:
                    (langString === "nl" ? "Deze tekst is naar je klembord gekopieerd,<br>deel het met vrienden!<br><br>" : "This text is copied to your clipboard,<br>share it with friends!<br><br>") +
                    textToShareResult.replace(/\n/g, "<br>"),
                  icon: "success",
                  confirmButtonText: "OK",
                  allowEnterKey: true,
                  customClass: {
                    popup: "custom-popup",
                    title: "custom-title",
                    content: "custom-content",
                    confirmButton: "custom-confirm-button",
                  },
                });
              })
              .catch((err) => {
                console.error("Clipboard copy failed:", err.message);
              });
          }
        });
    } else {
      console.error("Web Share API is not supported on this browser.");
    }
  };

  const handleShareResultWrongClick = async () => {
    logEvent(analytics, "shareResultButtonClicked", {});

    const date = new Date();
    const month = date.toLocaleString("en-EN", { month: "long" });
    let textToShareResult = "";

    textToShareResult = `🤓 SmartFriends\n🗓️ ${savedTime?.date} ❌\n🏆 Won in ${month}: ${wonThisMonth}\n🤯Are you smarter?`;

    if (langString === "nl") {
      const month = date.toLocaleString("nl-NL", { month: "long" });
      textToShareResult = `🤓 SmartFriends\n🗓️ ${savedTime?.date} ❌\n🏆 Gewonnen in ${month}: ${wonThisMonth}\n🤯Ben jij slimmer?`;
    }

    if (publisherID === "dpg") {
      const date = new Date();
      const month = date.toLocaleString("nl-NL", { month: "long" });
      textToShareResult = `🤓 SmartFriends\n🗓️ ${savedTime?.date} ❌\n🏆 Gewonnen in ${month}: ${wonThisMonth}\n🤯 Ben jij slimmer?`;

      PGSDK.gameShare({
        text: textToShareResult,
      });
    } else if (!navigator.share) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(textToShareResult)
          .then(function () {
            window.Swal.fire({
              title: langString === "nl" ? "Gekopieerd!" : "Copied!",
              html:
                (langString === "nl" ? "Deze tekst is naar je klembord gekopieerd,<br>deel het met vrienden!<br><br>" : "This text is copied to your clipboard,<br>share it with friends!<br><br>") +
                textToShareResult.replace(/\n/g, "<br>"),

              icon: "success",
              confirmButtonText: "OK",
              allowEnterKey: true,
              customClass: {
                popup: "custom-popup",
                title: "custom-title",
                content: "custom-content",
                confirmButton: "custom-confirm-button",
              },
            });
          })
          .catch(function (err) {
            console.error("Could not copy text: ", err);
            window.Swal.fire({
              title: langString === "nl" ? "Kopieer deze tekst en deel het met vrienden!" : "Copy this text and share it with friends!",
              html: textToShareResult.replace(/\n/g, "<br>"),
              text: textToShareResult.replace(/\n/g, "<br>"),
              confirmButtonText: "OK",
              allowEnterKey: true,
              customClass: {
                popup: "custom-popup",
                title: "custom-title",
                content: "custom-content",
                confirmButton: "custom-confirm-button",
              },
            });
          });
      }
    } else if (navigator.share) {
      await navigator
        .share({
          // title: "Share your score!",
          text: textToShareResult,
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => {
          console.error("Error sharing:", error.code);

             if (error.code !== 20 && navigator.clipboard) {
            navigator.clipboard
              .writeText(textToShareResult)
              .then(function () {
                window.Swal.fire({
                  title: langString === "nl" ? "Gekopieerd!" : "Copied!",
                  html:
                    (langString === "nl" ? "Deze tekst is naar je klembord gekopieerd,<br>deel het met vrienden!<br><br>" : "This text is copied to your clipboard,<br>share it with friends!<br><br>") +
                    textToShareChallenge.replace(/\n/g, "<br>"),
                  icon: "success",
                  confirmButtonText: "OK",
                  allowEnterKey: true,
                  customClass: {
                    popup: "custom-popup",
                    title: "custom-title",
                    content: "custom-content",
                    confirmButton: "custom-confirm-button",
                  },
                });
              })
          
              .catch((err) => {
                console.error("Clipboard copy failed:", err.message);
              });
          }  });
          
    } else {
      console.error("Web Share API is not supported on this browser.");
    }
  };

  const handleChallengeShareClick = async () => {
    logEvent(analytics, "shareChallengeButtonClicked", {});

    if (publisherID === "dpg") {
      PGSDK.gameShare({
        text: textToShareChallenge,
      });
    } else if (!navigator.share) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(textToShareChallenge)
          .then(function () {
            window.Swal.fire({
              title: langString === "nl" ? "Gekopieerd!" : "Copied!",
              html:
                (langString === "nl" ? "Deze tekst is naar je klembord gekopieerd,<br>deel het met vrienden!<br><br>" : "This text is copied to your clipboard,<br>share it with friends!<br><br>") +
                textToShareChallenge.replace(/\n/g, "<br>"),

              icon: "success",
              allowEnterKey: true,
              confirmButtonText: "OK",
              customClass: {
                popup: "custom-popup",
                title: "custom-title",
                content: "custom-content",
                confirmButton: "custom-confirm-button",
              },
            });
          })
          .catch(function (err) {
            console.error("Could not copy text: ", err);
            window.Swal.fire({
              title: langString === "nl" ? "Kopieer deze tekst en deel het met vrienden!" : "Copy this text and share it with friends!",
              html: textToShareChallenge.replace(/\n/g, "<br>"),
              text: textToShareChallenge.replace(/\n/g, "<br>"),
              confirmButtonText: "OK",
              allowEnterKey: true,
              customClass: {
                popup: "custom-popup",
                title: "custom-title",
                content: "custom-content",
                confirmButton: "custom-confirm-button",
              },
            });
          });
      }
    } else if (navigator.share) {
      await navigator
        .share({
          text: textToShareChallenge,
          // url: null,//window.location.pathname,
        })
        .then(() => console.log("Shared successfully"))
        // .catch((error) => console.error("Error sharing:", error.message)
        .catch((error) => {
          console.error("Error sharing:", error.code);

          if (error.code !== 20 && navigator.clipboard) {
            navigator.clipboard
              .writeText(textToShareChallenge)
              .then(function () {
                window.Swal.fire({
                  title: langString === "nl" ? "Gekopieerd!" : "Copied!",
                  html:
                    (langString === "nl" ? "Deze tekst is naar je klembord gekopieerd,<br>deel het met vrienden!<br><br>" : "This text is copied to your clipboard,<br>share it with friends!<br><br>") +
                    textToShareChallenge.replace(/\n/g, "<br>"),
                  icon: "success",
                  confirmButtonText: "OK",
                  allowEnterKey: true,
                  customClass: {
                    popup: "custom-popup",
                    title: "custom-title",
                    content: "custom-content",
                    confirmButton: "custom-confirm-button",
                  },
                });
              })
              .catch((err) => {
                console.error("Clipboard copy failed:", err.message);
              });
          }
        });
    } else {
      console.error("Web Share API is not supported on this browser.");
    }
  };

  const handleButtonChange = () => {
    setIsMenuModalOpen(true);
  };

  useEffect(() => {
    const myHandler = () => {
      console.log("onStart");
    };

    if (publisherID === "dpg") {
      // Register onStart handler

      PGSDK.onStart(myHandler);
    }

    // Cleanup: Unregister the onStart handler when the component unmounts
    return () => {
     
      PGSDK.onStart(null);
    };
  }, [publisherID]);

  const handleStartParams = (startParams) => {
    console.log("handleStartParams", startParams);
    let identValue = "";

    if (startParams) {
      if (startParams.userId) {
        identValue = startParams.userId;
      } else if (startParams.appId) {
        identValue = startParams.appId;
      }
    }

    userPublisherId = identValue;
    console.log("userPublisherId 9", userPublisherId);
    localStorage.setItem("userPublisherId", userPublisherId);

    // if (tempoUserPublisherID !== null) {
    //   setToCurrentExtUserOrCreate(tempoUserPublisherID);
    // } else {

    console.log("userPublisherId handleStartParams", userPublisherId);
    setToCurrentExtUserOrCreate(userPublisherId);
  };

  // ---------- DPG INJECT PARAMETERS ----------
  // useEffect(() => {

  //   const messageListener = (event) => {
  //     const data = event.data;
  //    console.log('messageListener',data);
  //    //&& data.action === "INVOKESTARTPARAMS"
  //     if (data) {
  //       console.log('messageListener222',data);
  //       const startParams = { ...data };

  //       handleStartParams(startParams);
  //     }
  //   };

  //   window.addEventListener("message", messageListener);

  //   return () => {
  //     console.log('removeEventListener');
  //     window.removeEventListener("message", messageListener);
  //   };
  // }, []);

  useEffect(() => {
    const messageListener = (event) => {
      try {
        const rawData = event.data;
        const data =
          typeof rawData === "string" ? JSON.parse(rawData) : rawData;

        if (data && data.action === "INVOKESTARTPARAMS") {
          console.log("Parsed message:", data);
          handleStartParams({ ...data });
        }
      } catch (e) {
        console.warn("Invalid message received:", event.data);
      }
    };

    window.addEventListener("message", messageListener);
    return () => {
      window.removeEventListener("message", messageListener);
    };
  }, []);

  //   useEffect(() => {
  //     handleStartParams(null);
  // }, []);

  useEffect(() => {
    //   const response: PlayerInfo = {
    //     playerId: string,
    //     publisherPlayerId: string,
    //     playerDisplayName: string,
    //     signature: string
    // }

    if (publisherID === "msn") {
      window.$msstart
        .getSignedInUserAsync()

        .then((response) => {
          // The promise resolves with the PlayerInfo object (defined below) which contains the Player ID (PLID)
          console.log(
            "PlayerInfo",
            response.playerId,
            response.playerDisplayName
          );
          setToCurrentExtUserOrCreate(response.playerId);
        })
        .catch((error) => {
          // The promise rejects because the user is not logged in or has not agreed to expose their identity to this game yet.
          console.log("PlayerInfo error", error);
        });
    }
  }, []);

  // ---------- SIGN IN NEW / EXISTING USER ----------
  const setToCurrentExtUserOrCreate = (id) => {
    if (tempoUserPublisherID !== null) {
      id = tempoUserPublisherID;
    }

    // //opheffen
    // userPublisherId = "usaPremium85476127956326";
    // id = "usaPremium85476127956326";

    console.log("Set current ExtUser Or Create new, id:", id);
    if (id) {
      const query = new Parse.Query("ExtUser");
      query.equalTo("userPublisherId", id);
      query
        .find()
        .then((response) => {
          console.log("EXTUSER response", response);

          //CREATE NEW USER
          if (!response || response === undefined || response.length === 0) {
            const ExtUser = Parse.Object.extend("ExtUser");
            const newExtUser = new ExtUser();
            newExtUser.set("userPublisherId", id);
            newExtUser.set("publisherId", publisherID);
            newExtUser.set("subPublisherId", publisherSubID);
            console.log("creating new user");

            if (
              publisherID === "crz" ||
              publisherID === "ark" ||
              publisherID === "huf" ||
              publisherID === "aze" ||
              publisherID === "tri" ||
              publisherID === "mng" ||
              publisherID === "usa" ||
              publisherID === "usaToday" ||
              publisherID === "wapo" ||
              publisherID === "erdee"
            ) {
              newExtUser.addUnique("rightToGeniusArray", -1);
              newExtUser.addUnique("rightToGeniusArray", -2);
              newExtUser.addUnique("rightToGeniusArray", -3);
              newExtUser.addUnique("rightToGeniusArray", -4);
              newExtUser.addUnique("rightToGeniusArray", -5);
              newExtUser.addUnique("rightToGeniusArray", -6);
              newExtUser.addUnique("rightToGeniusArray", -7);
            }

            console.log("isPremium", isPremium);
            if (isPremium) {
              for (let i = -1; i >= -500; i--) {
                newExtUser.addUnique("rightToGeniusArray", i);
              }
            }

            newExtUser.save().then(
              (newExtUser) => {
                getUserDataAndSaveToLocalStorage();
                console.log(
                  "New object created with objectId: " + newExtUser.id
                );
              },
              (error) => {
                console.log(
                  "Failed to create new object, with error code: " +
                    error.message
                );
              }
            );

            console.log("EXTUSER New user:", id);
          } else {
            //EXTUSER ALREADY EXISTS
            userPublisherId = response[0].get("userPublisherId");
            localStorage.setItem("userPublisherId", userPublisherId);

            getUserDataAndSaveToLocalStorage();
            console.log("EXTUSER Existing user:", userPublisherId);
          }
        })
        .catch((err) => {
          console.log("EXTUSER error = ", err);
        });
    }
  };

  useEffect(() => {
    if (tempoUserPublisherID !== null) {
      userPublisherId = tempoUserPublisherID;
    } else {
      if (localStorage.getItem("userPublisherId")) {
        userPublisherId = localStorage.getItem("userPublisherId");

      }
      
    }

    //opheffen
    //userPublisherId = "usaPremium85476127956326";



    if (userPublisherId) {
      //SIGNED IN USER, LATER: FINGERPRINT
      getUserDataAndSaveToLocalStorage();
    } else {
      //NO SIGNED IN USER, LOCALSTORAGE ONLY
      if (!localStorage.numbersPlayed) {
        localStorage.numbersPlayed = Number(0);
        setNumbersPlayed(localStorage.numbersPlayed);
      } else {
        setNumbersPlayed(localStorage.numbersPlayed);
      }

      // //WON THIS MONTH
      const date = new Date();
      const currentMonth = date.getMonth() + 1;

      if (Number(localStorage.lastPlayedMonth) !== currentMonth) {
        localStorage.lastPlayedMonth = currentMonth;
        localStorage.wonThisMonth = Number(0);
        setWonThisMonth(0);
      }
      //------------

      //STREAK AND MAX STREAK
      const playedIds = JSON.parse(localStorage.getItem("playedIds")) || [];
      const playedIdsOnlyIds = playedIds.map((item) => item.id);
      const hasIdOfYesterdaysChallenge = playedIds.some(
        (item) => item.id === diffInDays - 1
      );

      if (
        (!localStorage.streak || !hasIdOfYesterdaysChallenge) &&
        isGenius === false
      ) {
        if (isYesterdaysDayRiddle === false) {
          if (playedIdsOnlyIds.includes(idAsNumber) === true) {
            //STREAK WAS SET TO 0, BUT PLAYED TODAY AGAIN ---> STREAK TO 1
            localStorage.streak = Number(1);
            setStreak(Number(1));

            if (extUserObject) {
              extUserObject.set("currentStreak", Number(1));
              extUserObject.save();
            }
          } else {
            localStorage.streak = Number(0);
            setStreak(Number(localStorage.streak));
          }
        } else {
          setStreak(Number(localStorage.streak));
          console.log("initializing 1");
        }
      } else {
        setStreak(Number(localStorage.streak));
        console.log("initializing 2");
      }

      if (!localStorage.maxStreak) {
        localStorage.maxStreak = Number(0);
        setMaxStreak(Number(localStorage.maxStreak));
      } else {
        setMaxStreak(Number(localStorage.maxStreak));
      }

      if (!localStorage.won) {
        localStorage.won = Number(0);
        setWon(localStorage.won);
      } else {
        setWon(localStorage.won);
      }

      if (!localStorage.wonThisMonth) {
        localStorage.wonThisMonth = Number(0);
        setWonThisMonth(localStorage.wonThisMonth);
      } else {
        setWonThisMonth(localStorage.wonThisMonth);
      }
    }
  }, [idAsNumber]);

  const getUserDataAndSaveToLocalStorage = () => {
    const query = new Parse.Query("ExtUser");
    query.equalTo("userPublisherId", userPublisherId);

    query
      .first() //bij dubbele user creations, maak hier response[0] van. Rangschik.
      .then((response) => {
        setExtUserObject(response);

        extUserObject = response;

        // setNumbersPlayed(Number(response.get("numberOfRiddlesPlayed")));
        if (response.get("numberOfRiddlesPlayed") !== null) {
          setNumbersPlayed(Number(response.get("numberOfRiddlesPlayed")));
        }
        setWon(Number(response.get("numberOfRiddlesWon")));
        setStreak(Number(response.get("currentStreak")));
        setMaxStreak(Number(response.get("maxStreak")));
        setWonThisMonth(Number(response.get("wonThisMonth")));

        localStorage.numbersPlayed = Number(numbersPlayed);
        localStorage.won = Number(won);
        localStorage.streak = Number(streak);
        localStorage.maxStreak = Number(maxStreak);
        localStorage.wonThisMonth = Number(wonThisMonth);

        // //WON THIS MONTH
        lastPlayedMonth = Number(response.get("lastPlayedMonth"));

        const date = new Date();
        const currentMonth = date.getMonth() + 1;

        if (lastPlayedMonth !== currentMonth) {
          localStorage.wonThisMonth = Number(0);
          setWonThisMonth(0);
          if (extUserObject) {
            extUserObject.set("lastPlayedMonth", Number(currentMonth));
            extUserObject.set("wonThisMonth", Number(0));
            extUserObject.save();
          }
        }
        //------------

        let playedIdsOnlyIds = response.get("playedIds");
        let hasIdOfYesterdaysChallenge = playedIdsOnlyIds.includes(
          diffInDays - 1
        );

        if (!hasIdOfYesterdaysChallenge) {
          if (isYesterdaysDayRiddle === false) {
            if (extUserObject) {
              playedIdsOnlyIds = extUserObject.get("playedIds");
            }

            if (playedIdsOnlyIds.includes(idAsNumber)) {
              //STREAK WAS SET TO 0, BUT PLAYED TODAY AGAIN ---> STREAK TO 1
              localStorage.streak = Number(1);
              setStreak(Number(1));

              if (extUserObject) {
                extUserObject.set("currentStreak", Number(1));
                extUserObject.save();
              }
            } else {
              if (isGenius === false) {
                localStorage.streak = Number(0);
                setStreak(Number(0));
                // console.log(
                //   "STREAK SETTING to 0 in position 2",
                //   localStorage.streak
                // );
                if (extUserObject) {
                  extUserObject.set("currentStreak", Number(0));
                  extUserObject.save();
                }
              }
            }
          } else {
            setStreak(response.get("currentStreak"));
            //console.log("STREAK SETTING keeping the streak 1");
          }
        } else {
          setStreak(response.get("currentStreak"));
          //console.log("STREAK SETTING  keeping the streak 2");
        }

        if (!localStorage.maxStreak) {
          localStorage.maxStreak = Number(0);
          setMaxStreak(Number(localStorage.maxStreak));
        } else {
          //STILL NO IDEA WHY THIS IS REQUIRED:
          if (extUserObject) {
            localStorage.maxStreak = Number(extUserObject.get("maxStreak"));
          }
          //----
          setMaxStreak(Number(localStorage.maxStreak));
        }

        // console.log("fetched scores");
        // console.log("played:", numbersPlayed);
        // console.log("won:", won);
        // console.log("streak:", streak);
        // console.log("maxStreak:", maxStreak);

        // console.log("fetched scores localdata");
        // console.log("played:", localStorage.numbersPlayed);
        // console.log("won:", localStorage.won);
        // console.log("streak:", localStorage.streak);
        // console.log("maxStreak:", localStorage.maxStreak);
      })
      .catch((err) => {
        console.log("extUserObject error = ", err);
      });
  };

  const updateCountdown = () => {
    let now = new Date();
    let midnight = new Date();
    midnight.setHours(24, 0, 0, 0);

    let timeDiff = midnight - now;

    let hours = Math.floor(timeDiff / (1000 * 60 * 60));
    let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    setCountDownTimer(`${hours + ":"}${minutes + ":"}${seconds}`);

    globalCounter = `${hours + ":"}${minutes + ":"}${seconds}`;

    if (langString === "nl") {
      globalCounter = `${hours + "u"}${` ` + minutes + "m"}${
        ` en ` + seconds + `s`
      }`;
    } else {
      globalCounter = `${hours + "h"}${` ` + minutes + "m"}${
        ` and ` + seconds + `s`
      }`;
    }

    // console.log('countDownTimer',countDownTimer);
    // console.log('globalCounter',globalCounter);
  };

  useEffect(() => {
    let mustShow = true;
    if (localStorage.playedIds) {
      if (localStorage.playedIds.length > 0) {
        mustShow = false;
      }
    }

    if (mustShow === false || noIntroBoolean === true) {
      setIsIntroModalOpen(false);

      // if (publisherID === "dpg") {
      //   if (extUserObject) {
      //     let array = extUserObject.get("playedIds");
      //     console.log('arrayarrayarray',array);
      //     if (array.length <= 2) {
      //       console.log('hier');
      //       setIsIntroModalOpen(true);
      //     }

      //   }else{
      //     setIsIntroModalOpen(true);
      //   }

      // }
    } else {
      setIsIntroModalOpen(true);
    }
  }, []);

  //DPG INTRO
  useEffect(() => {
    if (publisherID === "dpg") {
      if (extUserObject) {
        let array = extUserObject.get("playedIds");

        if (array.length <= 3) {
          setIsIntroModalOpen(true);
        }
      } else {
        //setIsIntroModalOpen(true);
      }
    }
  }, [extUserObject]);

  useEffect(() => {
    //reset

    if (
      localStorage.playedIds &&
      JSON.parse(localStorage.playedIds).find((item) => item.id === (yestBoolean? idAsNumber+1: idAsNumber))
    ) {
      setAlreadyPlayed(true);
    } else {
      setAlreadyPlayed(false);
    }
  }, [idAsNumber]);

  useEffect(() => {
    if (langString === "nl") {
      const date = new Date();
      const month = date.toLocaleString("nl-NL", { month: "long" });
      setWonMonthDate(month);
    } else {
      const date = new Date();
      const month = date.toLocaleString("en-EN", { month: "long" });
      setWonMonthDate(month);
    }
  }, []);

  // useEffect(() => {
  //   if (forumEnabled && isYesterdayAnswerModalOpen && isGenius === false) {
  //     var currentDate = new Date();
  //     var dayNumber = currentDate.getDate();
  //     let discourceNumber = parseInt(dayNumber) + 21;
  //     if (discourceNumber === 49) {
  //       discourceNumber = 55
  //     }

  //     console.log("discourceNumber 1", discourceNumber);
  //     // discourceNumber = 15;

  //     axios
  //       .get(
  //         `https://smartfriends.discourse.group/t/${discourceNumber}/posts.json`
  //       )
  //       .then((res) => {
  //         setGetTopic(res.data);
  //       });
  //   }
  // }, [forumEnabled, isYesterdayAnswerModalOpen, isGenius]);

  const switchGenius = () => {
    if (isGenius === true && tableView === false) {
      setTableView(false);
    }

    if (tableView === true) {
      setIsPuzzleModal(false);
      setIsGenius(false);
      isGenius = false;
      idAsNumber = diffInDays;
      setTableView(false);

      fetchRiddle();
    } else {
      setIsPuzzleModal(false);

      forumEnabled = false;
      setTableView(true);

      if (
        extUserObject.get("numberOfGeniusPlayed") === 0 &&
        !localStorage.getItem("geniusIntroShown")
      ) {
        setIsIntroModalOpen(true);
        localStorage.setItem("geniusIntroShown", true);
      }

      //AZERION PRELOAD REWARD AD
      if (
        isAzerion === true &&
        window.gdsdk !== "undefined" &&
        window.gdsdk.preloadAd !== "undefined"
      ) {
        window.gdsdk
          .preloadAd("rewarded")
          .then((response) => {
            // A rewarded ad can be shown to user when he/she clicked it.
            console.log("reward ad preloaded");
          })
          .catch((error) => {
            // Any Rewarded ad is not available to user.
          });
      }

      //  const numberOfGeniusPlayed = extUserObject.get("numberOfGeniusPlayed");
      //   if (numberOfGeniusPlayed === 0) {
      //     setIsIntroPopupOpen(true);
      //   }
    }

    //  getGeniusModal();
  };

  const getGeniusModal = () => {
    setOpenGeniusModal(true);
  };

  const handleTableViewCellClick = (clickedCell) => {
    let rightToGeniusArray = [0];
    if (extUserObject && extUserObject.get("rightToGeniusArray")) {
      rightToGeniusArray = extUserObject.get("rightToGeniusArray");
    }

    let geniusPlayedArray = [0];
    if (extUserObject && extUserObject.get("geniusPlayedArray")) {
      geniusPlayedArray = extUserObject.get("geniusPlayedArray");
    }

    //CRZ HAS ACCESS TO EVERYTHING
    if (publisherID !== "crz") {
      // console.log('geniusPlayedArray.length',geniusPlayedArray.length);
      // geniusPlayedArray.length = 32

      switch (true) {
        case geniusPlayedArray.length < 32:
          if (clickedCell + 1 > 32) {
            setIsLevelWarningModalOpen(true);
            setTimeout(() => setIsLevelWarningModalOpen(false), 2500);
            return;
          }
          break;

        case geniusPlayedArray.length >= 32 && geniusPlayedArray.length < 64:
          if (clickedCell + 1 > 64) {
            setIsLevelWarningModalOpen(true);
            setTimeout(() => setIsLevelWarningModalOpen(false), 2500);
            return;
          }

          break;

        case geniusPlayedArray.length >= 64 && geniusPlayedArray.length < 96:
          if (clickedCell + 1 > 96) {
            setIsLevelWarningModalOpen(true);
            setTimeout(() => setIsLevelWarningModalOpen(false), 2500);
            return;
          }
          break;
        default:
          console.log("Unexpected length");
      }
    }

    if (rightToGeniusArray.includes(-(clickedCell + 1)) === false) {
      if (publisherID === "crz") {
        const callbacks = {
          adFinished: () => console.log("End rewarded ad"),
          adError: (error) => console.log("Error rewarded ad", error),
          adStarted: () => console.log("Start rewarded ad"),
        };
        window.CrazyGames.SDK.ad.requestAd("rewarded", callbacks);
      } else if (
        publisherID === "usa" ||
        publisherID === "usaToday" ||
        publisherID === "wapo" ||
        publisherID === "erdee"
      ) {
        //TEMPORARY USING LEVELWARNING FOR USA TODAY NON-PREMIUM
        setIsLevelWarningModalOpen(true);
        setTimeout(() => setIsLevelWarningModalOpen(false), 2500);
        return;
      } else {
        extUserObject.addUnique("rightToGeniusArray", -(clickedCell + 1));
        extUserObject.save();
      }

      //Azerion Reward
      if (
        typeof window.gdsdk !== "undefined" &&
        window.gdsdk.showAd !== "undefined" &&
        isAzerion === true
      ) {
        if (
          window.gdsdk !== "undefined" &&
          window.gdsdk.showAd !== "undefined"
        ) {
          window.gdsdk
            .showAd("rewarded")
            .then((response) => {
              // Ad process done. You can track "SDK_REWARDED_WATCH_COMPLETE" event if that event triggered, that means the user watched the advertisement completely, you can give reward there.
              console.log("reward ad completed");
              extUserObject.addUnique("rightToGeniusArray", -(clickedCell + 1));
              extUserObject.save();
            })
            .catch((error) => {
              // An error catched. Please don't give reward here.
              console.log("reward ad skipped", error);
            });
        }
      }

      //Arkadium reward
      if (publisherID === "ark") {
        async function loadARKad() {
          if (arksdk.ads.showRewardAd) {
            arksdk.ads
              .showRewardAd()

              .then((reward) => {
                console.log("Reward received: " + reward.value);
                extUserObject.addUnique(
                  "rightToGeniusArray",
                  -(clickedCell + 1)
                );
                extUserObject.save();
              });
          }
        }
        loadARKad();
      }

      // extUserObject.addUnique("rightToGeniusArray", -(clickedCell + 1));
      // extUserObject.save();
    } else if (geniusPlayedArray.includes(-(clickedCell + 1)) === false) {
      if (publisherID === "crz" && numbersPlayed > adTriggerSolution) {
        const callbacks = {
          adFinished: () => {
            console.log("End midgame ad");
          },
          adError: (error) => console.log("Error midgame ad", error),
          adStarted: () => console.log("Start midgame ad"),
        };
        window.CrazyGames.SDK.ad.requestAd("midgame", callbacks);
      }
    }

    setIsGenius(true);
    isGenius = true;

    idAsNumber = -Number(clickedCell + 1);
    localStorage.setItem("lastSelectedGenius", idAsNumber);

    // if (isGenius && extUserObject.get("numberOfGeniusPlayed") === 0) {
    //   setIsIntroModalOpen(true);
    // }

    setTableView(false);

    if (publisherID === "crz") {
      window.CrazyGames.SDK.game.gameplayStart();
    }

    fetchRiddle();
  };

  const challenges = [];

  let rightToGeniusArray = [0];
  let geniusPlayedArray = [0];

  if (extUserObject && extUserObject.get("rightToGeniusArray")) {
    rightToGeniusArray = extUserObject.get("rightToGeniusArray");
  }

  if (extUserObject && extUserObject.get("geniusPlayedArray")) {
    geniusPlayedArray = extUserObject.get("geniusPlayedArray");
  }

  if (isPremium) {
    //opheffen
    console.log("new please check");
    for (let i = -1; i >= -500; i--) {
      rightToGeniusArray.push(i);
    }
  }

  for (let i = 1; i <= 64; i++) {
    challenges.push({
      id: i,
      label: `${i}`,
      isLocked: !rightToGeniusArray.includes(-i),
      isPlayed: geniusPlayedArray.includes(-i),
    });
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setStart(false);
      animate();
    }, 2500);

    let count = 0;

    const animate = () => {
      setIsAnimating(true);
      setTimeout(() => {
        setIsAnimating(false);
        count++;
        if (count < 3) {
          setTimeout(animate, 400);
        }
      }, 400);
    };

    //setIsLoading(true);
    // result = null;
    return () => clearTimeout(timeout);
  }, []);

  // Tell the portal wrapper to show its subtle back button once the homepage is visible
  useEffect(() => {
    if (portalHomeReadySentRef.current) return;
    if (start) return;
    if (!result || isLoading) return;

    portalHomeReadySentRef.current = true;
    try {
      window.parent?.postMessage?.({ type: "SF_PORTAL_HOME_READY" }, "*");
    } catch (e) {
      // ignore
    }
  }, [start, result, isLoading]);

  useEffect(() => {
    if (!hideButtonsBoolean) return;
    if (window.parent === window) return;

    let lastHeight = 0;
    const sendHeight = () => {
      const height =
        Math.ceil(
          Math.max(
            document.documentElement.scrollHeight,
            document.body.scrollHeight,
            document.documentElement.offsetHeight,
            document.body.offsetHeight
          )
        ) + 8;
      if (Math.abs(height - lastHeight) < 2) return;
      lastHeight = height;
      try {
        window.parent.postMessage({ type: "SF_WIDGET_HEIGHT", height }, "*");
      } catch (e) {
        // ignore
      }
    };

    sendHeight();
    const observer = new ResizeObserver(sendHeight);
    observer.observe(document.body);
    window.addEventListener("load", sendHeight);
    return () => {
      observer.disconnect();
      window.removeEventListener("load", sendHeight);
    };
  }, [hideButtonsBoolean, start, result, isLoading]);

  return start ? (
    <LoadAnimation />
  ) : result && !isLoading ? (
    <>
      <div
        className={`w-full h-full flex flex-col gap-2 relative ${
          !tableView && !hideButtonsBoolean ? "justify-between" : ""
        }${hideButtonsBoolean ? " hide-buttons" : ""}`}
      >
        <div
          className={
            isGenius || tableView ? "widget-header-genius" : "widget-header"
          }
        >
          <div
            className="widget-header-img"
            style={{ marginTop: !alreadyPlayed ? "8px" : "" }}
          >
            {!alreadyPlayed ? (
              isMaxHeight ? (
                <img
                  src={isGenius || tableView ? geniusLogo : newLogo}
                  alt=""
                  style={
                    isGenius || tableView
                      ? { width: "135px", height: "42px", marginBottom: "7px" }
                      : { width: "97px", height: "25px", marginBottom: "10px" }
                  }
                  onClick={() => {
                    if (!isGenius) {
                      setIsYesterdayAnswerModalOpen(true);
                      setYestBoolean(true);
                    }
                  }}
                />
              ) : (
                <img
                  src={isGenius || tableView ? geniusLogo : smartLogo}
                  alt=""
                  onClick={() => {
                    if (!isGenius) {
                      setIsYesterdayAnswerModalOpen(true);
                      setYestBoolean(true);
                    }
                  }}
                />
              )
            ) : isMaxHeight ? (
              <img
                src={isGenius || tableView ? geniusLogo : newLogo}
                alt=""
                onClick={() => {
                  if (!isGenius) {
                    setIsYesterdayAnswerModalOpen(true);
                    setYestBoolean(true);
                  }
                }}
                style={
                  isGenius || tableView
                    ? { width: "135px", height: "42px", marginBottom: "7px", cursor: "pointer" }
                    : { width: "97px", height: "25px", marginBottom: "10px", cursor: "pointer" }
                }
              />
            ) : (
              <img 
                style={{ cursor: "pointer" }} 
                src={isGenius || tableView ? geniusLogo : NextLogo}
                alt=""
                onClick={() => {
                  if (!isGenius) {
                   
                    setIsYesterdayAnswerModalOpen(true);
                    setYestBoolean(true);
                    localStorage.setItem("backdropPart3NotNeedToShow", "true");
                  }
                }} 
              />
            )}
          </div>
          {isMaxHeight ? null : (
            <div className="widget-header-date">
              {!alreadyPlayed ? (
                <span 
                  style={{ marginTop: "13px", cursor: "pointer" }}
                  onClick={() => {
                    if (!isGenius) {
    
                      setIsYesterdayAnswerModalOpen(true);
                      setYestBoolean(true);
                      localStorage.setItem("backdropPart3NotNeedToShow", "true");
                    }
                  }}
                >{hideButtonsBoolean ? "\u00A0" : WidgetHeaderDate()}</span>
              ) : (
                <span style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (!isGenius) {
                      
                      setIsYesterdayAnswerModalOpen(true);
                      setYestBoolean(true);
                      localStorage.setItem("backdropPart3NotNeedToShow", "true");
                    }
                  }}
                >{isGenius || tableView ? "\u00A0" : countDownTimer}</span>
              )}
            </div>
          )}

          <Dashes />
          <div
            className="top-right-square"
            style={{
              position: "absolute",
              top: "0px",
              right: "0px",
              width: "60px",
              height: "60px",
              backgroundColor: "#fde244",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {(geniusEnabled || geniusPurchaseEnabled) &&
              numbersPlayed >= 0 &&
              extUserObject && (
                <div
                  onClick={switchGenius}
                  className={`genius-button ${isAnimating ? "pulse" : ""}`}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: tableView || isGenius ? "49%" : "46%",
                      left: tableView || isGenius ? "48%" : "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    {tableView || isGenius ? "X" : "+"}
                  </span>
                </div>
              )}
          </div>
        </div>
        {!tableView ? (
          <div className={`widget-body`}>
            <div
              className={!result.attributes?.questionImage ? "scrollable" : ""}
              onClick={handleWidgetClick}
            >
              {/* style={{ fontSize: calculateFontSize(result.attributes?.questionText) }} */}
              <p className={`header text-center`}>
                {langString === "nl"
                  ? result.attributes?.questionTextNL
                  : result.attributes?.questionText}
              </p>
            </div>
            {result.attributes?.questionImageNL ||
            result.attributes?.questionImage ? (
              <div
                onClick={hideButtonsBoolean ? undefined : handleZoomClick}
                className="widget-image flex flex-col justify-center items-center"
              >
                <img
                  src={
                    langString === "nl" &&
                    result.attributes?.questionImageNL?._url
                      ? result.attributes?.questionImageNL?._url
                      : result.attributes?.questionImage?._url
                  }
                  alt=""
                  style={{ height: "100%" }}
                />
              </div>
            ) : null}

            <div className="puzzle-body">
              <div>
                <ColoredDivider />
                <ColoredDivider />
              </div>
              {result.attributes?.type !== "openAnswer" ? (
                <div
                  className="flex justify-evenly gap-4"
                  style={{ padding: "0 10px" }}
                >
                  {result.attributes?.answerImage1 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={result.attributes?.answerImage1?._url}
                      indicator="A"
                      handleClick={(indicator) => handleAnswerClick(indicator)}
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                    />
                  ) : null}
                  {result.attributes?.answerImage2 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={result.attributes?.answerImage2?._url}
                      indicator="B"
                      handleClick={(indicator) => handleAnswerClick(indicator)}
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                    />
                  ) : null}
                  {result.attributes?.answerImage3 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={result.attributes?.answerImage3?._url}
                      indicator="C"
                      handleClick={(indicator) => handleAnswerClick(indicator)}
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                    />
                  ) : null}
                  {result.attributes?.answerImage4 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={result.attributes?.answerImage4?._url}
                      indicator="D"
                      handleClick={(indicator) => handleAnswerClick(indicator)}
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                    />
                  ) : null}
                  {result.attributes?.answerImage5 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={result.attributes?.answerImage5?._url}
                      indicator="E"
                      handleClick={(indicator) => handleAnswerClick(indicator)}
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                    />
                  ) : null}
                  {result.attributes?.answerImage6 ? (
                    <EachDecision
                      isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
                      url={result.attributes?.answerImage6?._url}
                      indicator="F"
                      handleClick={(indicator) => handleAnswerClick(indicator)}
                      selectedIndicator={selectedIndicator}
                      idAsNumber={idAsNumber}
                    />
                  ) : null}
                </div>
              ) : (
                <div>
                  {isPuzzleModal ? (
                    <div className="flex justify-center">
                      {!isSuccess ? (
                        <div className="wrong-answer">
                          <div onClick={handleOpenAnswerClick}>
                            {isAnswerInputValue.toUpperCase()}
                          </div>
                          <div onClick={handleOpenAnswerClick}>
                            {puzzleCaseResponce}
                          </div>
                        </div>
                      ) : (
                        <div
                          className="correct-answer"
                          onClick={handleOpenAnswerClick}
                        >
                          {puzzleCaseResponce}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      <div className="answer-type flex justify-center flex-column align-items-center">
                        <Form.Control
                          type="text"
                          className="text-input"
                          readOnly
                          placeholder={languageString.typeYourAnswerTitle}
                          onClick={() => {
                            setIsAnswerModalOpen(true);
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center">
            <div
              className="tableView-header"
              style={{
                fontSize: "25px",
                marginLeft: "20px",
                marginRight: "20px",
              }}
            >
              {langString === "nl"
                ? "Kies een genius challenge, begin met level 1 ↓"
                : "Select a genius challenge, start with level 1 ↓"}
            </div>
            <div className="tableView-body" style={{ border: "none" }}>
              {Array.from({ length: challenges.length }).map((_, index) => {
                const challenge = challenges[index];

                return (
                  <React.Fragment key={index}>
                    {/* Full-width level bar every 32 cells */}
                    {index % 32 === 0 && index !== 0 && (
                      <div
                        className="level-bar col-span-full text-center bg-[#fdfbee] flex justify-center items-center m-0 border-0"
                        style={{ height: "90px" }}
                      >
                        {/* <img src={lock} alt="lock icon" className="mr-2 w-6 h-6" style={{ filter: 'brightness(0) saturate(100%)' }} /> */}
                        <div
                          style={{
                            fontFamily: "Union",
                            fontSize: "25px",
                            color: "black",
                          }}
                        >
                          {/* Level {index / 32 + 1} ↓ */}
                          <div
                            style={{
                              fontFamily: "Union",
                              fontSize: "28px",
                              color: "black",
                              marginLeft: "20px",
                              marginRight: "20px",
                            }}
                          >
                            {langString === "nl"
                              ? index / 32 + 1 === 2
                                ? `↓ Level ${index / 32 + 1}, voor hele slimmerikken`
                                : index / 32 + 1 === 3
                                  ? `↓ Level ${index / 32 + 1}, voor logica-legendes`
                                  : index / 32 + 1 === 4
                                    ? `↓ Level ${index / 32 + 1}, alleen voor genieën`
                                    : `↓ Level ${index / 32 + 1} ↓`
                              : index / 32 + 1 === 2
                                ? `↓ Level ${index / 32 + 1}, for real smarties`
                                : index / 32 + 1 === 3
                                  ? `↓ Level ${index / 32 + 1}, for logic legends`
                                  : index / 32 + 1 === 4
                                    ? `↓ Level ${index / 32 + 1}, only for geniuses`
                                    : `↓ Level ${index / 32 + 1} ↓`}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Individual challenge cell */}
                    <div
                      onClick={() => handleTableViewCellClick(index)}
                      className={`tableView-content w-[70px] h-[70px] text-center cursor-pointer ${
                        challenge
                          ? challenge.isLocked
                            ? "#fdfbee"
                            : "#fdfbee"
                          : "#fdfbee"
                      }`}
                    >
                      {challenge ? (
                        challenge.isLocked ? (
                          <img
                            src={lock}
                            alt=""
                            style={{
                              width: "30px",
                              height: "30px",
                              opacity: 1,
                            }}
                          />
                        ) : challenge.isPlayed ? (
                          <img
                            src={played}
                            alt=""
                            style={{ width: "30px", height: "30px" }}
                          />
                        ) : (
                          challenge.label
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
            {/* <div className="tableView-body">
              {Array.from({ length: challenges.length }).map((_, index) => {
                const challenge = challenges[index];
                return (
                  
                  
                  <div
                    key={index}
                    
                    onClick={() => handleTableViewCellClick(index)}
                    className={`tableView-content w-[70px] h-[70px] text-center cursor-pointer ${
                      
                      challenge
                        ? challenge.isLocked
                          ? "#fdfbee"
                          : "#fdfbee"
                        : "#fdfbee"
                    }`}
                  >
                    {
                    challenge ? (
                      challenge.isLocked ? (
                        <img
                          src={lock}
                          alt=""
                          style={{ width: "30px", height: "30px", opacity: 1 }}
                        />
                      ) : challenge.isPlayed ? (
                        <img
                          src={played}
                          alt=""
                          style={{ width: "30px", height: "30px" }}
                        />
                      ) : (
                        challenge.label
                      )
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
            </div> */}
            <p className="tableView-header" style={{ fontSize: "22px" }}>
              {langString === "nl" ? "Binnenkort meer!" : "More coming soon!"}
            </p>
          </div>
        )}

        {!tableView && !hideButtonsBoolean && (
          <div className="widget-footer">
            <div>
              <button
                className="changing-buttons"
                onClick={() => setIsScoreModalOpen(true)}
              >
                <img src={Schermafbeelding} alt="" />
              </button>
            </div>
            <div className="challenge-btn">
              <Button onClick={handleChallengeShareClick}>
                {languageString.titleChallengeFriends}
              </Button>
            </div>
            <div>
              <button className="changing-buttons" onClick={handleButtonChange}>
                <img src={yesterdayButton} alt="" />
              </button>
            </div>
          </div>
        )}
      </div>
      <MenuModal
        isMenuModalOpen={isMenuModalOpen}
        handleCancelClick={handleCancelClick}
        setIsYesterdayAnswerModalOpen={setIsYesterdayAnswerModalOpen}
        setYestBoolean={setYestBoolean}
        yestBoolean={yestBoolean}
        isLoadingYesterday={isLoadingYesterday}
        resultYesterday={resultYesterday}
        setIsIntroModalOpen={setIsIntroModalOpen}
        languageString={languageString}
        setIsMenuModalOpen={setIsMenuModalOpen}
        isGenius={isGenius}
        setOpenFaqModal={setOpenFaqModal}
        changeHeader={changeHeader}
        setIsTodaysExplanationForPremium={setIsTodaysExplanationForPremium}
      />
      <YesterdayAnswerModal
        isYesterdayAnswerModalOpen={isYesterdayAnswerModalOpen}
        setIsYesterdayAnswerModalOpen={setIsYesterdayAnswerModalOpen}
        handleYesterdayAnswerClose={handleYesterdayAnswerClose}
        resultYesterday={resultYesterday}
        langString={langString}
        languageString={languageString}
        isAlreadyAnsweredBorder={isAlreadyAnsweredBorder}
        selectedIndicator={selectedIndicator}
        idAsNumber={idAsNumber}
        isTodaysDayRiddle={isTodaysDayRiddle}
        publisherID={publisherID}
        isLoadingYesterday={isLoadingYesterday}
        puzzleCaseResponce={puzzleCaseResponce}
        setDataFromChild={setDataFromChild}
        getTopic={getTopic}
        isAzerion={isAzerion}
        forumEnabled={forumEnabled}
        dataFromChild={dataFromChild}
        setHereURL={setHereURL}
        isTodaysExplanationForPremium={isTodaysExplanationForPremium}
        handleShareResultGoodClick={handleShareResultGoodClick}
        handleShareResultWrongClick={handleShareResultWrongClick}
        handleChallengeShareClick={handleChallengeShareClick}
        isGenius={isGenius}
        setIsCommentModalOpen={setIsCommentModalOpen}
        formattedComments={formattedComments}
        setFormattedComments={setFormattedComments}
        quotePrefill={quotePrefill}
        setQuotePrefill={setQuotePrefill}
      />
      <WriteCommentModal
        isOpen={isCommentModalOpen}
        onClose={() => {
          setIsCommentModalOpen(false);
          setQuotePrefill("");
          setComment("")
        }}
        onSubmit={handleSubmitComment}
        comment={comment}
        setComment={setComment}
        difficulty={difficulty}
        setDifficulty={setDifficulty}
        langString={langString}
        quotePrefill={quotePrefill}
      />

      <ConfirmModal
        isConfirmModalOpen={isConfirmModalOpen}
        handleCancelClick={handleCancelClick}
        handleDecisionClick={handleDecisionClick}
        areYouSureTitle={languageString.areYouSureTitle}
        noTitle={languageString.noTitle}
        yesTitle={languageString.yesTitle}
        languageString={languageString}
      />
      <IntroModal
        isIntroModalOpen={isIntroModalOpen}
        setIsIntroModalOpen={setIsIntroModalOpen}
        handleIntroModalClose={handleIntroModalClose}
        langString={langString}
        setIsMenuModalOpen={setIsMenuModalOpen}
        publisherID={publisherID}
        isGenius={isGenius}
        tableView={tableView}
      />
      <LevelWarning
        isLevelWarningModalOpen={isLevelWarningModalOpen}
        langString={langString}
        publisherID={publisherID}
      />

      <WebModal
        setWebModalOpen={dataFromChild}
        // setWebModalOpen={setWebModalOpen}
        handleWebModalClose={handleWebModalClose}
        getTopic={getTopic}
        hereURL={hereURL}
      ></WebModal>
      <TypeAnswerModal
        isAnswerModalOpen={isAnswerModalOpen}
        handleTypeAnswerModalClose={handleTypeAnswerModalClose}
        handleDecisionClick={handleDecisionClick}
        setIsAnswerInputValue={setIsAnswerInputValue}
        isAnswerInputValue={isAnswerInputValue}
        languageString={languageString}
      />

      <ScoreModal
        isScoreModalOpen={isScoreModalOpen}
        handleScoreModalClose={handleScoreModalClose}
        numbersPlayed={numbersPlayed}
        won={won}
        streak={streak}
        maxStreak={maxStreak}
        wonThisMonth={wonThisMonth}
        wonMonthDate={wonMonthDate}
        languageString={languageString}
      />
      <ZoomingModal
        isZoomModalOpen={isZoomModalOpen}
        handleZoomModalClose={handleZoomModalClose}
        result={result}
        langString={langString}
        setIsZoomCaseModal={setIsZoomCaseModal}
      />
      <Genius
        setOpenGeniusModal={setOpenGeniusModal}
        openGeniusModal={openGeniusModal}
        handleGeniusModalClose={handleGeniusModalClose}
        getGeniusChallenge={getGeniusChallenge}
        geniusPurchaseEnabled={geniusPurchaseEnabled}
      />

      <FaqModal
        openFaqModal={openFaqModal}
        handleFaqModalClose={handleFaqModalClose}
      />

      <ZoomCase
        isZoomCaseModal={isZoomCaseModal}
        setIsZoomCaseModal={setIsZoomCaseModal}
        setIsZoomModalOpen={setIsZoomModalOpen}
      />
      {/* Dialog Section */}
      <PuzzleCaseModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        changeHeader={changeHeader}
        languageString={languageString}
        isSuccess={isSuccess}
        result={result}
        isTodaysDayRiddle={isTodaysDayRiddle}
        formatTime={formatTime}
        formatDate={formatDate}
        isYesterdaysDayRiddle={isYesterdaysDayRiddle}
        handleShareResultGoodClick={handleShareResultGoodClick}
        handleShareResultWrongClick={handleShareResultWrongClick}
        savedTime={savedTime}
        isShareModalOpen={isShareModalOpen}
        setIsShareModalOpen={setIsShareModalOpen}
        publisherID={publisherID}
        langString={langString}
        showTextCopied={showTextCopied}
        textToShareChallenge={textToShareChallenge}
        numbersPlayed={numbersPlayed}
        won={won}
        streak={streak}
        maxStreak={maxStreak}
        wonThisMonth={wonThisMonth}
        wonMonthDate={wonMonthDate}
        isTodayModalOpen={isTodayModalOpen}
        isGenius={isGenius}
        setIsPuzzleCaseModalClosed={setIsPuzzleCaseModalClosed}
        hideButtonsBoolean={hideButtonsBoolean}
      />
      <PopupWithBackdrop
        isIntroPopupOpen={isIntroPopupOpen}
        setIsIntroPopupOpen={setIsIntroPopupOpen}
        isGenius={isGenius}
        tableView={tableView}
        geniusEnabled={geniusEnabled}
        geniusPurchaseEnabled={geniusPurchaseEnabled}
        langString={langString}
        isPuzzleCaseModalClosed={isPuzzleCaseModalClosed}
        numbersPlayed={numbersPlayed}
        setIsPuzzleCaseModalClosed={setIsPuzzleCaseModalClosed}
        hideButtonsBoolean={hideButtonsBoolean}
      />
    </>
  ) : (
    <div className="loader">
      <OrbitProgress
        variant="dotted"
        color="black"
        size="small"
        text=""
        textColor=""
      />
    </div>
  );
}

export default HomePage;
